<template>
  <div class="map-container">
    <div class="map-desktop" v-if="device === 'desktop'">
      <img
        class="call-to-action"
        :src="`${baseUrl}images/C2_CTA_map${$ml.current === 'IT' ? '' : '_en'}.svg`"
      >
      <svg
        version="1.1"
        id="Livello_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1601.8 759.7"
        style="enable-background:new 0 0 1601.8 759.7;"
        xml:space="preserve"
      >
        <title>map</title>
        <g>
          <g>
            <g id="Livello_9">
              <path
                id="Tanzania"
                class="st0"
                d="M973.8,515.5l-2.1-20l2.1-3l-6.3-5.7h-3.8l-3-2.7h-3.1l-10.3-9.2l-2.6,2.4v4.2h-3.9l-2.3,2.1
				l-3.3-2.9l-6,5.3l0.4,7.7l-5.2,2.9v12.1l6.7,6h5.3l6,5.5l4.7,0.1v4.5l2.7,2.3l1.8-1.3c0.5-0.8,1.6-1,2.4-0.4
				c0.1,0.1,0.3,0.2,0.4,0.4l0.7,0.7c0.6,0.5,1.5,0.8,2.3,0.8c0.8,0,1.5-0.2,2.1-0.7l1-0.8h7.7l2.5-2.2h3.6l4.2-3.3L973.8,515.5z"
              ></path>
              <g id="Chile">
                <polygon
                  class="st0"
                  points="423.2,754.1 423.2,748.5 426.3,745.8 426.3,741.3 432.5,741.3 439.6,747.4 447.4,747.4 
					440.2,753.6 440.2,759.4 428,759.4 428,754.1 				"
                ></polygon>
                <path
                  class="st0"
                  d="M419.3,569.9l0,8.5c0,1.5-0.5,2.9-1.5,4c-1.3,1.2-2.1,2.8-2.1,4.6v9.7c0,2.9-1.3,5.6-3.5,7.4
					c-1.4,1.2-2.2,2.9-2.2,4.7v39.3l-2.9,2.6c-0.8,0.8-1.2,1.9-1.2,3c0.1,1.7,1,3.2,2.5,4c0.6,0.5,1,1.3,1,2.2c0,0.8-0.3,1.5-0.8,2
					l-0.6,0.5c-1.3,1.1-2.1,2.8-2.1,4.6v43.6l4.1,3.4c0.8,0.6,1.2,1.5,1.2,2.5c0,1-0.4,1.9-1.2,2.5l-3,2.6l11.6,9.9h8v8h-2.8
					c-2-0.1-3.7,1.3-3.9,3.3v3.9l-6-5.2h-4v-8.7l-9.2-7.9c-2.5-2-4.1-5.1-4.1-8.4v-14.8l4.5-3.8v-22l-4.8,4.2v-30.8l5.1-4.4v-24.4
					l-2.4-2c-0.8-0.6-1.2-1.5-1.2-2.4c0-0.9,0.4-1.8,1.1-2.3l3.8-3.2v-46.8l-4.8-4.1v-8.8l9.3,0.2l5.1,4.4v8.4L419.3,569.9z"
                ></path>
              </g>
              <rect id="Lussemburgo" x="803.7" y="202.1" class="st0" width="7.7" height="6.8"></rect>
              <g id="Greenland_Danimarca">
                <polygon
                  id="Islanda"
                  class="st0"
                  points="641.9,116.2 651.5,116.2 663,109.4 666.8,109.4 671.1,105.8 671.1,102.1 666.3,98 
					666.3,93.9 659.8,91.8 653.7,97.1 650.2,97.1 647.7,94.9 634.4,98.6 634.4,93.1 628.8,93.1 626,95.6 621.2,95.6 621.2,98.2 
					624.9,101.4 629.3,101.4 627.5,104.8 622.6,104.8 622.6,108.3 627.3,108.3 630.2,110.8 637,110.8 				"
                ></polygon>
                <path
                  class="st0"
                  d="M523.2,91.9l-13.1-11.2l6.3-5.3v-5.1H528v-3.2h-5.9v-3.6l8.6-0.2V52.9l-4.2-3.5v-6.6l-5.3-5.8l-4.8,4.2H510
					l7.9-6.7H516c-1.7,0.1-3.2-1.1-3.3-2.8l0.1-7.1l-23-19.7h-13.3l-2.9,2.6h-11.9v-7h210.3l-6.7,5.6l6.8,5.8l-4,3.4l-5.5-4.7
					l-3.1,2.7l10.5,9v3l-7.3-6.2v4c0,2-1.9,3.6-4.2,3.6c-1.4,0-2.7-0.6-3.6-1.8c-1-1.4-2.7-2.2-4.4-2.1c-1.3,0-2.6,0.4-3.7,1.3
					l-1.8,1.5c-1.1,0.9-1.8,2.3-1.8,3.8c0,2.9,2.8,5.3,6.2,5.3l2.1-0.1c1.4-0.1,2.7,1,2.8,2.4V39l9.5,8.2l-6,2.5l-7-6h-5.2l-8.6,7.5
					h14.7v7.4h-6.4l-54.4,25.7h-4.4V79l-24.5,25.5v8.3l-5,4.3v6.1h-9.4v-7.4h-16V112l-9.2-12.8l9-7.7l-3.7-3.2L523.2,91.9z"
                ></path>
                <path class="st0" d="M515.2,66.8c-1.8,0.1-3.4-1.2-3.5-3l0-2.5h12.1v5.4L515.2,66.8z"></path>
              </g>
              <g id="Guiana_francese">
                <path
                  class="st0"
                  d="M481.9,444.8l5.4,4.6l9.6-8.2l-5.7-4.8v-2.2c-0.2-2-1.9-3.6-4-3.5h-9.7V441L481.9,444.8z"
                ></path>
              </g>
              <g id="Argentina">
                <polygon
                  class="st0"
                  points="432.9,741.2 440,747.3 447.7,747.3 440.6,753.4 440.6,759.2 				"
                ></polygon>
                <path
                  class="st0"
                  d="M426.6,726.2l7.6-6.5v-5.3l6-5.2h-7.4v-8c0-1.5,0.7-2.9,1.9-3.8l3-2.5c1.7-1.4,2.7-3.4,2.7-5.6V676
					c0-2.2,2.1-4,4.6-4h2.3l5.7-4.9v-2.4c0.1-1.7,1.6-2.9,3.3-2.8h3.3c2.3,0,4.6-0.8,6.4-2.3l7.5-6.4h5v-6.1l-4.5-3.8h-6.9v-6.2
					l4.1-3.6l7,5.9c2,1.6,4.9,1.6,6.9,0l3.9-3.4v-5.5l4.4-3.8l-8.7-7.4c-2.1-1.7-4.7-2.7-7.4-2.8c-2.5,0-4.5-1.7-4.5-3.9
					c0-1.2,0.7-2.4,1.7-3.1l9.1-7.8l0.1-10.6L472,601.4h-5l-3.6-3.1v-5.6h4.2v-3.5l-6.9-5.9h-8.3l-7.6-6.5v-5.3h-8.3l-5,4.3l-4.7-4
					h-5.1l-2.2-1.7l0,8.5c0,1.5-0.5,2.9-1.5,4c-1.3,1.2-2.1,2.8-2.1,4.6v9.7c0,2.9-1.3,5.6-3.5,7.4c-1.4,1.2-2.2,2.9-2.2,4.7v39.3
					l-2.9,2.6c-0.8,0.8-1.2,1.9-1.2,3c0.1,1.7,1,3.2,2.5,4c0.6,0.5,1,1.3,1,2.2c0,0.8-0.3,1.5-0.8,2l-0.6,0.5
					c-1.3,1.1-2.1,2.8-2.1,4.6v43.6l4.1,3.4c0.8,0.6,1.2,1.5,1.2,2.5c0,1-0.4,1.9-1.2,2.5l-3,2.6l11.6,9.9h8L426.6,726.2z"
                ></path>
              </g>
              <g id="Perù">
                <path
                  class="st0"
                  d="M407.6,521.9l-8.3-7.1v-5.9h-4.6c-6.1,0-11-4.2-11-9.4c0-2.6,1.2-5,3.2-6.6l2-1.7l-2.2-1.9
					c-1.2-0.9-1.4-2.5-0.6-3.7c0.1-0.2,0.3-0.4,0.5-0.5l3.6-3.1h2.2c4.7,0,8.6-3.3,8.6-7.3v-4.1h-11.9l-5,4.3v-6.5l-12.5-10.7h-8.1
					l-8.1-7l-7.5,6.6v12.7l-2.5,2.1c-1.6,1.3-2.5,3.1-2.5,5.1v11.2c0,2.6,1.4,5,3.5,6.5l8.3,7.1v5.9l10.7,9.2l-0.1,9.9
					c0.1,3.8,2.3,7.2,5.8,8.9l26.7,15.2h10c-0.5-0.9-0.8-1.9-0.8-2.9c0-1.8,0.9-3.6,2.3-4.7c0.9-0.7,1.4-1.8,1.4-2.9
					c0-0.9-0.4-1.8-1-2.5c-1.3-1.4-2-3.2-2-5.1L407.6,521.9z"
                ></path>
                <path
                  class="st0"
                  d="M407.6,521.9l-8.3-7.1v-5.9h-4.6c-6.1,0-11-4.2-11-9.4c0-2.6,1.2-5,3.2-6.6l2-1.7l-2.2-1.9
					c-1.2-0.9-1.4-2.5-0.6-3.7c0.1-0.2,0.3-0.4,0.5-0.5l3.6-3.1h2.2c4.7,0,8.6-3.3,8.6-7.3v-4.1h-11.9l-5,4.3v-6.5l-12.5-10.7h-8.1
					l-8.1-7l-7.5,6.6v12.7l-2.5,2.1c-1.6,1.3-2.5,3.1-2.5,5.1v11.2c0,2.6,1.4,5,3.5,6.5l8.3,7.1v5.9l10.7,9.2l-0.1,9.9
					c0.1,3.8,2.3,7.2,5.8,8.9l26.7,15.2h10c-0.5-0.9-0.8-1.9-0.8-2.9c0-1.8,0.9-3.6,2.3-4.7c0.9-0.7,1.4-1.8,1.4-2.9
					c0-0.9-0.4-1.8-1-2.5c-1.3-1.4-2-3.2-2-5.1L407.6,521.9z"
                ></path>
                <path
                  class="st1"
                  d="M407.6,521.9l-8.3-7.1v-5.9h-4.6c-6.1,0-11-4.2-11-9.4c0-2.6,1.2-5,3.2-6.6l2-1.7l-2.2-1.9
					c-1.2-0.9-1.4-2.5-0.6-3.7c0.1-0.2,0.3-0.4,0.5-0.5l3.6-3.1h2.2c4.7,0,8.6-3.3,8.6-7.3v-4.1h-11.9l-5,4.3v-6.5l-12.5-10.7h-8.1
					l-8.1-7l-7.5,6.6v12.7l-2.5,2.1c-1.6,1.3-2.5,3.1-2.5,5.1v11.2c0,2.6,1.4,5,3.5,6.5l8.3,7.1v5.9l10.7,9.2l-0.1,9.9
					c0.1,3.8,2.3,7.2,5.8,8.9l26.7,15.2h10c-0.5-0.9-0.8-1.9-0.8-2.9c0-1.8,0.9-3.6,2.3-4.7c0.9-0.7,1.4-1.8,1.4-2.9
					c0-0.9-0.4-1.8-1-2.5c-1.3-1.4-2-3.2-2-5.1L407.6,521.9z"
                ></path>
                <g>
                  <defs>
                    <path
                      id="SVGID_1_"
                      d="M407.6,521.9l-8.3-7.1v-5.9h-4.6c-6.1,0-11-4.2-11-9.4c0-2.6,1.2-5,3.2-6.6l2-1.7l-2.2-1.9
							c-1.2-0.9-1.4-2.5-0.6-3.7c0.1-0.2,0.3-0.4,0.5-0.5l3.6-3.1h2.2c4.7,0,8.6-3.3,8.6-7.3v-4.1h-11.9l-5,4.3v-6.5l-12.5-10.7
							h-8.1l-8.1-7l-7.5,6.6v12.7l-2.5,2.1c-1.6,1.3-2.5,3.1-2.5,5.1v11.2c0,2.6,1.4,5,3.5,6.5l8.3,7.1v5.9l10.7,9.2l-0.1,9.9
							c0.1,3.8,2.3,7.2,5.8,8.9l26.7,15.2h10c-0.5-0.9-0.8-1.9-0.8-2.9c0-1.8,0.9-3.6,2.3-4.7c0.9-0.7,1.4-1.8,1.4-2.9
							c0-0.9-0.4-1.8-1-2.5c-1.3-1.4-2-3.2-2-5.1L407.6,521.9z"
                    ></path>
                  </defs>
                  <clipPath id="SVGID_2_">
                    <use xlink:href="#SVGID_1_" style="overflow:visible;"></use>
                  </clipPath>
                  <g class="st2">
                    <path
                      class="st3"
                      d="M376.8,462.5l-8.2,14.3l-6.1,10.7l-1.5,6.6c0,0-12.2-0.5-14.8-1"
                    ></path>
                  </g>
                </g>
                <path
                  class="st4"
                  d="M407.6,521.9l-8.3-7.1v-5.9h-4.6c-6.1,0-11-4.2-11-9.4c0-2.6,1.2-5,3.2-6.6l2-1.7l-2.2-1.9
					c-1.2-0.9-1.4-2.5-0.6-3.7c0.1-0.2,0.3-0.4,0.5-0.5l3.6-3.1h2.2c4.7,0,8.6-3.3,8.6-7.3v-4.1h-11.9l-5,4.3v-6.5l-12.5-10.7h-8.1
					l-8.1-7l-7.5,6.6v12.7l-2.5,2.1c-1.6,1.3-2.5,3.1-2.5,5.1v11.2c0,2.6,1.4,5,3.5,6.5l8.3,7.1v5.9l10.7,9.2l-0.1,9.9
					c0.1,3.8,2.3,7.2,5.8,8.9l26.7,15.2h10c-0.5-0.9-0.8-1.9-0.8-2.9c0-1.8,0.9-3.6,2.3-4.7c0.9-0.7,1.4-1.8,1.4-2.9
					c0-0.9-0.4-1.8-1-2.5c-1.3-1.4-2-3.2-2-5.1L407.6,521.9z"
                ></path>
              </g>
              <path
                id="Ecuador"
                class="st5"
                d="M361.6,501.6l2.4-2.4c-0.6-0.5,0-3.9,0-4.7s-3.6-6.6-3-7.1l8.2-6.5v-7.7
				c4.7,0,2.4-15.9,2.4-15.9h-8.1l-8.1-7l-7.5,6.6v12.7l-2.5,2.1c-1.6,1.3-2.5,3.1-2.5,5.1v11.2c0,2.6,1.4,5,3.5,6.5l8.3,7.1
				L361.6,501.6z"
              ></path>
              <path
                id="Perù-2"
                class="st5"
                d="M410.7,540.4c0-0.9-0.4-1.8-1-2.5c-1.3-1.4-2-3.2-2-5.1v-10.8l-8.3-7.1v-5.9h-4.6
				c-6.1,0-11-4.2-11-9.4c0-2.6,1.2-5,3.2-6.6l2-1.7l-2.2-1.9c-1.2-0.9-1.4-2.5-0.6-3.7c0.1-0.2,0.3-0.4,0.5-0.5l3.6-3.1h2.2
				c4.7,0,8.6-3.3,8.6-7.3v-4.1h-12l-5,4.3v-6.5l-12.5-10.7c0,0,2.4,15.9-2.4,15.9v7.7l-8.2,6.5c-0.6,0.5,2.9,6.3,2.9,7.1
				s-0.6,4.2,0,4.7l-2.4,2.4l-6.9,0.1v5.9l10.7,9.2l-0.1,9.9c0.1,3.8,2.3,7.2,5.8,8.9l26.7,15.2h10c-0.5-0.9-0.8-1.9-0.8-2.9
				c0-1.8,0.9-3.6,2.3-4.7C410.1,542.6,410.6,541.5,410.7,540.4z"
              ></path>
              <g id="venezuela">
                <path
                  class="st0"
                  d="M446.6,431.9l-11,9.4l-0.9-0.8c-0.4-0.3-0.9-0.5-1.5-0.5c-1.1-0.1-2.1,0.8-2.2,1.9v4.7l-6.4,5.5
					c-1.2,1-2.7,1.6-4.3,1.6c-1.5,0-2.9-0.5-4.1-1.4l-2.1-1.8v-8.9l-4-3.4v-6c0-2-1-3.9-2.5-5.2l-9.2-7.9c-1.3-1.1-3-1.8-4.7-2
					c-4.1-0.5-7.3-3.6-7.3-7.2v-3.6l4.3-3.9v-4.3c0.1-1.1,1.1-2,2.2-1.9c0,0,0,0,0,0c0.6,0,1.2,0.2,1.6,0.6l2.9,2.5h3
					c1.6,0,3.1,0.5,4.3,1.5l7,6.1c1.5,1.2,3.4,1.9,5.3,1.9h13.5l2.7-2.3c0.8-0.7,1.8-1,2.8-1c1,0,2,0.4,2.8,1l7.6,6.5L446.6,431.9z"
                ></path>
              </g>
              <g id="Guyana">
                <path
                  class="st0"
                  d="M456.4,421.8h-9.7l-0.1,10.1h5.1v17.4l1.5,1.4c1.2,1.2,2.8,1.8,4.5,1.8c1.7,0,3.4-0.6,4.6-1.9l4.8-4.2
					l-6.6-5.6l4.1-11.5L456.4,421.8z"
                ></path>
              </g>
              <g id="Suriname">
                <path
                  class="st0"
                  d="M484.4,446.9c-0.6-0.7-1.5-1-2.5-1c-0.9,0-1.7,0.3-2.3,0.9l-3.2,2.8l-4.2-3.6c-1.3-1.1-3.2-1-4.5,0.1
					l-0.6,0.4l-6.6-5.6l3.6-10.1h13.3V441l4.4,3.8L484.4,446.9z"
                ></path>
              </g>
              <g id="colombia">
                <path
                  class="st0"
                  d="M390.8,402.4l-17.1-0.1v11.5l-5.6,4.8c-2.4,1.9-3.8,4.8-3.8,7.9v16.6l-8.8,7.4l8.1,7h8.1l12.5,10.7v6.6
					l5-4.3h11.9v-7.9c0-1.4-0.7-2.7-1.8-3.6l-2.3-2v-2.7c0-2.1,2-3.8,4.4-3.8h12.8v-8.9l-4-3.4v-6c0-2-1-3.9-2.5-5.2l-9.2-7.9
					c-1.3-1.1-3-1.8-4.7-2c-4.1-0.5-7.3-3.6-7.3-7.2v-3.6L390.8,402.4z"
                ></path>
              </g>
              <g id="Bolivia">
                <path
                  class="st0"
                  d="M409.3,543.3c0.9-0.7,1.4-1.8,1.4-2.9c0-0.9-0.4-1.8-1-2.5c-1.3-1.4-2-3.2-2-5.1v-10.8l7.1-6.1v-4.3
					l6.8-5.9v7.9l3,2.6c1.2,1,1.9,2.4,1.9,4c0.4,2,2.2,3.3,4.2,3.2h3.9l3.3-2.8l5.5,4.8v0.7c0.1,2.3,2,4.2,4.3,4.4
					c3.3,0.3,5.9,2.9,5.9,5.9l0,0c0,1.3,0.6,2.5,1.6,3.4l6.4,5.5v12.5h-11.8c-2.9,0-5.3,2-5.3,4.5l0.1,9h-8.3l-5,4.3l-4.7-4h-5.1
					c0,0-10.1-8-9.3-8v-8.4l-2.9-2.5c-2.6-2.1-3.1-5.9-1-8.5C408.6,543.8,408.9,543.5,409.3,543.3"
                ></path>
              </g>
              <path
                id="Paraguay"
                class="st0"
                d="M444.6,576.7l7.6,6.5h8.3l6.9,5.9v3.5h-4.2v5.6l3.7,3.1h5l11.8-10.1v-12.8h-8.3v-4.8l-5.1-4.4
				v6.4l-3-2.6v-8.4c0-1.4-0.7-2.7-1.8-3.6l-3.9-3.3h-11.8c-2.9,0-5.3,2-5.3,4.5L444.6,576.7z"
              ></path>
              <g id="Brasile">
                <path
                  class="st0"
                  d="M493.5,626.8l-8.7-7.4c-2.1-1.7-4.7-2.7-7.4-2.8c-2.5,0-4.5-1.7-4.5-3.9c0-1.2,0.7-2.4,1.7-3.1l9.1-7.8
					v-23.4h-8.3v-4.8l-5.1-4.4v6.5l-3-2.6v-8.4c0-1.4-0.7-2.7-1.8-3.6l-3.9-3.3v-12.5l-6.4-5.5c-1-0.9-1.5-2.1-1.6-3.4l0,0
					c0-3-2.5-5.5-5.9-5.9c-2.3-0.2-4.1-2.1-4.3-4.4v-0.8l-5.5-4.7l-3.3,2.8h-3.9c-2,0.1-3.8-1.2-4.2-3.2c0-1.6-0.7-3-1.9-4l-3-2.6
					v-7.9l-6.8,5.9v4.3l-7.1,6.1l-8.3-7.1v-5.9h-4.6c-6.1,0-11-4.2-11-9.4c0-2.6,1.2-5,3.2-6.6l2-1.7l-2.2-1.9
					c-0.7-0.5-1.1-1.3-1.1-2.1c0-0.8,0.4-1.6,1-2.1l3.6-3.1h2.2c4.7,0,8.6-3.3,8.6-7.3v-12c0-1.4-0.7-2.7-1.8-3.6l-2.3-2v-2.7
					c0-2.1,2-3.8,4.4-3.8h12.9l2.1,1.8c1.2,0.9,2.6,1.4,4.1,1.4c1.6,0,3.1-0.5,4.3-1.6l6.4-5.5v-4.7c0.1-1.1,1.1-2,2.2-1.9
					c0.5,0,1.1,0.2,1.5,0.5l0.9,0.7l11-9.4h5.1v17.4l1.5,1.4c1.2,1.2,2.8,1.8,4.5,1.8c1.7,0,3.4-0.7,4.6-1.9l5.3-4.6
					c1.3-1.1,3.2-1.1,4.5-0.1l4.2,3.6l3.2-2.8c0.6-0.6,1.4-0.9,2.3-0.9c0.9,0,1.8,0.4,2.5,1l2.9,2.5l9.6-8.2l5.6,4.8
					c1.9,1.5,3.1,3.8,3.1,6.2c-0.1,2.6-1.3,5-3.4,6.5l-5.6,4.7l16.4,0c4.4,0,8.6,1.5,12,4.3l8.2,7.2h23.9l7.3,6.2v3.9
					c0.1,1.6,1.5,2.8,3.1,2.7h0.9c5.8,0,10.5,4,10.5,9v6.9c0,1.3-0.6,2.5-1.6,3.3l-10.6,9c-1.5,1.3-2.4,3.1-2.4,5.1v2.3
					c-0.1,1.5-1.3,2.7-2.9,2.8c-2.6,0-4.7,1.8-4.7,4v26.7c-0.1,5.1-2.5,9.9-6.6,12.9l-5.8,4.8H536l-16.4,14h-3c-3.4,0-6,2.3-6,5.2
					v9.3l-5.3,4.6v6.2H500l-4.3,3.7l4.4,3.8L493.5,626.8z"
                ></path>
              </g>
              <polygon
                id="Cuba"
                class="st0"
                points="330.5,352.2 333.1,347.5 342.1,343.4 355.2,343.4 357.2,345.2 362.6,345.2 372.4,349.8 
				376.6,348.6 378.1,350.6 384.3,350.6 384.3,352.8 367.9,357.8 367.9,356.5 369.7,354.5 368.4,352.3 363.8,352.3 361.9,349.4 
				355.6,349.4 354,348 344.8,348 343.7,346.5 340.9,346.5 335.6,351.6 331.2,353.4 			"
              ></polygon>
              <polygon
                id="Jamaica"
                class="st0"
                points="363.8,365.6 363.8,367.6 371.5,369.4 372.8,367.7 376.6,367.7 375.2,365.3 			"
              ></polygon>
              <polygon
                id="Haiti"
                class="st0"
                points="390.4,351.4 397.4,351.4 400.8,348.9 407.9,348.9 409.5,350.2 412.8,350.2 416.3,352.2 
				414.9,354.5 408.7,354.5 407,357.6 404.4,356.5 402.4,358.3 402.4,360.9 399.9,360.9 399.9,358.3 389.9,362.6 385.5,362.6 
				385.5,360.2 389,360.2 395.4,357.6 393.1,355.1 393.1,353.4 389.1,353.4 			"
              ></polygon>
              <path
                id="guatemala"
                class="st0"
                d="M308.1,384.9c0.6-0.7,1.4-1,2.3-1h0.9l0.9-1.5l-1.3-1.2l3.9-3.3l-1.2-1.1l-1.4,1l-0.9-0.7
				h-2.5v-6.5h-7.8v1.6c-1-0.1-1.9,0.7-1.9,1.6c0,0,0,0,0,0c0,0.4,0.2,0.7,0.4,1l1.9,2.2h-1.9c-1.3,0-2.5,0.6-3.1,1.8l-1,2v4.4
				l1.6,1.2h6.2l2.5,0.9l0,0L308.1,384.9z"
              ></path>
              <path
                id="costarica"
                class="st0"
                d="M343.5,405.5v-6.4l-3.3-2.6c-1.1-1.1-1.8-2.6-2-4.2h-8.9c-1.1-0.1-2,0.7-2.1,1.8v3.6h3
				l-1,0.8c-0.5,0.2-0.8,0.7-0.8,1.2c0,0.6,0.4,1.1,0.9,1.3l2.5,1.1l1.8-1.6l5.7,3.4v1.6L343.5,405.5z"
              ></path>
              <path
                id="Panama"
                class="st0"
                d="M347.7,402.5c1,0.6,2.2,0.9,3.3,0.9c1.2,0,2.4-0.3,3.4-0.9l2.6-1.2l1.5-1.6
				c0.8-1.1,2.2-1.7,3.5-1.7h6l5.6,4.1v10.4l-5-6.5c-0.4-0.4-0.6-0.9-0.6-1.4c0-0.5,0.2-1.1,0.6-1.4l1.1-0.9h-4.5l-2.3-1.4l-3.5,1.3
				v2.1l-3.1,1.5l3.5,2l-4.8,1.9l-5-2.8l-6.6-1.3v-6.4L347.7,402.5z"
              ></path>
              <path
                id="el_salvador"
                class="st0"
                d="M311.3,384h-0.9c-0.9,0-1.7,0.3-2.3,1l-2.6,2.3l0,0l2.2,0.8h3.2l1.9,1l5.5-0.6v1.5l3.3-2.8
				L318,384H311.3z"
              ></path>
              <g id="honduras">
                <path
                  class="st0"
                  d="M310.9,381.3l1.3,1.2l-0.9,1.5h6.7l3.7,3.2h4.8c1.3,0.1,2.5-0.8,2.9-2.1c0.1-0.9,0.6-1.7,1.3-2.3l5.2-4.4
					l-4.1-3.2l-1.9,1l-11.4,1.4L317,376L310.9,381.3z"
                ></path>
              </g>
              <path
                id="nicaragua"
                class="st0"
                d="M336.9,378.6l1.5,0c1-0.1,1.8,0.7,1.9,1.6l-2.1,12h-8.8c-1.1-0.1-2,0.7-2.1,1.8v1.4l-8.7-5.5
				l3.3-2.8h4.8c1.3,0.1,2.5-0.8,2.9-2.1c0.1-0.9,0.6-1.7,1.3-2.3l5.2-4.4L336.9,378.6z"
              ></path>
              <path
                id="panama-2"
                class="st0"
                d="M343.4,399.1l4.3,3.4c1,0.6,2.2,0.9,3.3,0.9c1.2,0,2.4-0.3,3.4-0.9l2.6-1.2l1.5-1.6
				c0.8-1.1,2.2-1.7,3.5-1.7h6l5.6,4.1v10.4l-5-6.5c-0.4-0.4-0.6-0.9-0.6-1.4c0-0.5,0.2-1.1,0.6-1.4l1.1-0.9h-4.5l-2.3-1.4l-3.5,1.3
				v2.1l-3.1,1.5l3.5,2l-4.8,1.9l-5-2.8l-6.6-1.3L343.4,399.1z"
              ></path>
              <g id="USA">
                <polygon
                  class="st0"
                  points="422.3,349.7 421.3,352.3 422.9,353.4 424.8,351.5 428.8,351.5 432.4,348.8 430.6,347.7 
					425.2,349.7 				"
                ></polygon>
                <path
                  class="st0"
                  d="M309.3,202.1c3.3-0.1,6.4,1.7,7.9,4.7c1.5,2.9,4.6,4.8,7.9,4.6c1.9,0,3.8-0.6,5.4-1.7
					c1.1-0.8,2.4-1.2,3.7-1.2c3.2,0,5.8,2.2,5.8,5v3.4l-5.5,4.7v17l6.4-5.5v-8.9l5-4.3c1-0.9,2.2-1.3,3.5-1.3c2.6,0,4.7,1.8,4.7,4
					c0,0.3-0.1,0.5-0.1,0.8c-0.1,0.3-0.2,0.5-0.2,0.8c0,2,2,3.6,4.3,3.6l0.1,6.8h4.1l-5.1,4.4h9.9l9.3-7.8c2.6-2.6,6.2-4,9.9-3.9
					h23.9l7.3-6.2v-6.8h5.2l3.5-3h4.9v17.4h-6c-2.1,0-4.1,0.7-5.6,2.1l-3,2.5c-1.4,1.3-2.3,3.2-2.3,5.2l0,1c0,3.6-3.4,6.5-7.6,6.5
					h-4.7l-4.8,4.2v3.3c-0.1,1.9-1.8,3.4-3.8,3.2h-2.9v5.4h-2.4l-4.5-3.9v8.8c0,1.3,0.5,2.5,1.3,3.5c0.8,1,1.2,2.2,1.2,3.4
					c0,1.7-0.8,3.3-2.1,4.4l-6.9,5.9h-1.1c-3.8,0-6.9,2.6-6.9,5.9v2.3c-0.1,1.4-1.3,2.5-2.8,2.4h-0.7l0,2.2
					c-0.1,1.4-1.3,2.5-2.7,2.4c0,0,0,0-0.1,0c-1.7,0-3.4,0.6-4.7,1.8l-5.1,4.5c-0.4,0.3-0.7,0.9-0.7,1.4c0,0.5,0.3,1.1,0.7,1.4
					l1.6,1.5v7.9l2.5,2.1v11.7l-4.3,3.6h-4.7v-11.1l-3.3-2.9v-6.4c0-2.8-2.6-5-5.9-5h-10.1l-4.5-3.9c-2.5-2-6-2-8.5,0l-4.5,3.9h-7.8
					l-3.2,2.8l-2.1-1.9c-2.4-2-5.9-1.9-8.3,0.1l-6.6,5.8c-1.4,1.1-3.1,1.7-4.9,1.7c-2.2,0-4.1,1.5-4.1,3.4v7h-5.6l-8.4-7.2
					c-1.7-1.3-2.7-3.3-2.8-5.5v-4.4l-4-3.4h-3.1c-1.8-0.1-3.5,1.2-3.6,3.1v2.4l-3.3-2.8v-6l-6.6-5.6c-1.9-1.6-4.3-2.4-6.7-2.4
					c-2.2,0-4.4,0.7-6.2,2l-0.6,0.6h-15c-4.1,0-8-1.3-11.2-3.9l-9.6-8.3h-9.5h-5c-4.5,0-8.1-3.1-8.1-6.9v-5.1l-4.1-3.5v-4.2
					l-7.7-6.6c-1.4-1-2.2-2.6-2.2-4.4c0-1.8,0.9-3.5,2.4-4.5l2.2-1.9v-11.3c0-2.7,1.3-5.2,3.5-6.8l2-1.7v-9.5l6.4-5.5l-6-5.2h8.3
					l4.1,3.6V202h81.1l7.1,4.4h13.5l4.5-4.4L309.3,202.1z"
                ></path>
                <path
                  class="st0"
                  d="M43.9,151.2l8.7-7.4v7.9l-2.3,2v3.5c0,0-6.2,0.1-6.2,0L43.9,151.2z"
                ></path>
                <path
                  class="st0"
                  d="M139.5,141.8v-5l-5.2-4.4h-7.6l-4.2,3.6l-9.5-8.2v-5.2l19.9-48v-9.3l-5.3-4.6l-4.1,3.5H111L99.2,54.1
					l-4.9,4.2H77.6v-6.6H65.4c-4.5-0.1-8.9,1.4-12.4,4.3l-10.9,9.3v4.6h-23v6.3h7.6l6.5,5.6v8.3h-10l-6.2-6v6H6v8.8h22.8v5.3h-6.6
					l-4.7,4h-4.3L0.4,119.3L0.3,125h7.4v6.5h5.2v10.4l5-4.3l4.8,4.1h6.4v3.7l-11.8,10.1h-6.2v5h11.1l14.4-12.3h6.1l9.1-7.8v-6h5.8
					L70.9,123v5.8l-10.8,9.3v3.8L77.5,127v-4.3h8.4v5.3H97l6.4,5.5h9.8l9.8,8.3H139.5z"
                ></path>
              </g>
              <g id="canada">
                <polygon
                  class="st0"
                  points="151.6,191.1 163.1,200.8 163.1,205.9 158.2,201.7 151.6,201.7 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="343.3,39.1 346.7,36.1 346.7,27.8 353.3,27.8 356.8,30.8 362,30.8 365.2,33.6 358.9,39.1 				"
                ></polygon>
                <path class="st0" d="M342.9,21.9l4,3.4h7.8c0.4,0,0-5.2,0-5.2l-4.9-4.1L342.9,21.9z"></path>
                <polygon
                  class="st0"
                  points="407.5,83.8 417.7,83.8 422.7,79.5 422.7,76.7 415.2,76.7 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="260.6,39.3 270.5,44.9 270.5,40.6 278.6,40.6 283.4,44.7 283.4,47.7 287.6,47.7 287.6,39 297.5,39 
					297.5,56.7 310,56.7 310.1,62.2 303.1,68.1 294.9,68.1 282.5,61.3 271.8,70.5 257.1,70.5 245.9,60.9 260,60.9 260,55.1 
					242.3,55.1 249.2,48.9 237.6,48.9 248.5,39.3 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="403.7,38.1 403.7,43.7 400.9,46.1 416.6,46.1 421,42.3 430.3,42.3 430.3,51.8 437.5,47.1 
					437.5,56.3 454.1,56.3 454.1,60.7 459.5,60.7 464.4,64.9 454.1,64.8 454.1,74.3 467.6,85.8 482.4,85.8 482.4,94.2 464.8,94.3 
					454.9,85.8 450.5,89.5 464,101 464,110.9 453.1,111 446.7,105.4 443.3,105.4 443.3,109.3 453.6,118.2 450.7,120.7 442.2,113.4 
					426.8,113.5 426.8,107.9 418.9,101.7 401.4,101.8 406.9,97.2 420.7,97.2 420.7,91.1 428.6,84.2 428.5,75 415.6,66.3 415.6,61.6 
					409.4,56.3 409.4,63.7 404.9,63.7 398.5,58.2 367.8,58.2 363.6,54.6 371,54.6 363.6,49.1 363.6,42 369.9,42 369.9,36.7 
					376.8,36.7 384.5,30.2 390,30.2 377.4,41 377.4,52.1 382.7,52.1 382.7,46.8 387.4,42.8 387.4,38.1 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="365.4,24.6 360.6,24.5 360.6,15.7 368.9,8.6 423.2,8.6 423.2,10.8 398.8,10.8 395.5,13.6 
					371.6,13.6 367.7,17 371.3,20.2 382.2,20.2 390.7,22.3 408,18.7 409.8,27.9 382.4,27.8 379.2,30.6 				"
                ></polygon>
                <path
                  class="st0"
                  d="M337.4,43.7l-7.2,8h-5.6v2.9l-4.9,0.1c-1.4,0.1-2.6-0.9-2.7-2.3v-3.6c-0.2-1.9-1.8-3.3-3.7-3.2h-2.2V40
					h10.4v-3.9l-2.6-2.2l7.6-6.5l5.4,4.6v8.3L337.4,43.7z"
                ></path>
                <path
                  class="st0"
                  d="M314.9,12.4c-1.6-0.1-2.9,1-3,2.6c0,0.8,0.4,1.5,1,2l2.5,2.1h7.4v4.6h10l7.4-6.4v-3.2c0-2.8-2.6-5-5.8-5
					H328v3.3H314.9z"
                ></path>
                <polygon
                  class="st0"
                  points="373,115.2 378,110.9 381.9,114.2 377.7,117.7 373,117.7 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="471.6,209.1 471.6,202 477.9,202 493.8,188.4 496.5,190.8 491.2,195.3 496.7,200.1 502.4,200.1 
					502.4,210 496.7,214.9 496.7,208.8 492.6,212.3 488.9,209.1 				"
                ></polygon>
                <polygon class="st0" points="134,176.8 134,168.2 139.2,172.7 139.2,182.2 				"></polygon>
                <path
                  class="st0"
                  d="M430.8,228.5v-17.3H426l-3.5,3h-5.2l19.2-16.4h10.5l3.5,3v3.9h-11.2l6.8,5.8v6.1c-0.2,2.1-2,3.7-4.1,3.5
					h-1.5L430.8,228.5z"
                ></path>
                <path
                  class="st0"
                  d="M448.9,219.4c1-0.9,2.4-1.3,3.7-1.3c1.3,0,2.6,0.4,3.6,1.2l4.9,4.2l-6.8,5.8h-5.9l-4.8,4.1l-10.9-0.1
					L448.9,219.4z"
                ></path>
                <polygon
                  class="st0"
                  points="363.7,108.4 374.9,98.8 374.9,94.2 380.9,99.3 380.9,103.1 392.8,103.1 392.8,106 381.7,106 
					378.2,103.1 371.3,109 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="381.9,160.7 381.7,153.7 389.6,153.7 389.6,157.6 386,160.7 				"
                ></polygon>
                <path
                  class="st0"
                  d="M417.3,214.1h-11.7l28.2-24.1h28.8l4.4,3.8c0,0,7.9-6.4,7.5-6.4h6.4l10.1-8.7v-6.8H482l-4.2,3.6v-7l6.3-5.4
					h-14.8l0-12.7c0-1.9-0.9-3.8-2.4-5l-1.5-1.3c-2.1-1.5-3.3-3.9-3.4-6.5v-10.8l-8.1,7v5.8l-10.5,9v-8.7h-10.8v-12.7l-14.7-12.6
					v6.7l-3.7-3.3l-13.2-0.1v11.8l-4,4.6v8.9l4,3.7v10.5L386,167.8v18.5h-6.4l-4-3.4H371l0.1-15.4c-0.2-2-1.9-3.6-4-3.5l-6.4,0.1
					c-1.5-1.5-3.2-2.8-4.8-4.1h-10l-11.4-9.8v3.3h-5.3v-4.6c-0.1-2.7-2-5-4.6-5.7c-2.8-0.8-4.9-3.1-4.9-5.7c0-1.2,0.4-2.3,1.1-3.2
					l10.1-14.6c1.6-2,4-3.3,6.5-3.4c2.4,0,4.5-1.7,4.5-3.8V109l7.1-6.1v3.7h6.8l4.8-4.2c0.9-0.7,1.4-1.7,1.5-2.8
					c0-1.4-0.8-2.6-2-3.3c-1.1-0.6-1.7-1.8-1.8-3.1c0-2.1,2-3.8,4.5-3.8h4.1c1.1,0,2.1-0.5,2.8-1.5c0.5-1.1,1.7-1.8,2.9-1.8
					l19.9-0.2V74.7l4.7-4l-7.3-6.2h-10.3V72l-3.5,3.1c-1.4,0.9-2.2,2.4-2.2,4v2.1h-6.6v-5.7l3.6-3.1l-3.4-3l-5.4,5.9h-10.9V54.2
					l-7.5-6.4l-6.7,6.3v21.3h-3.9v10.5H327V75.4h-7.2v4.2h-24.2l-11-9.1l-6.7,5.7l3,2.6l-7.7,6.6l-5.9-5.1h-19.6L236,70h-10.1
					l-6.4-5.4h-3.8l-3.1,2.7h-12.8v-8.9l-5.5-4.7v6.5h-4.4c-2.9,0-5.7,1-8,2.9l-5.9,5h-8.1v4.3h-14.5l-8.1-7L133,65.4v9.3l-19.9,48
					v5.2l9.5,8.1l4.2-3.6h7.6l5.2,4.4v5l12.1,21.1v7c0.1,3.1,1.7,6,4.4,7.6c2.3,1.6,3.7,4.3,3.8,7.1v5.2l14,12.1h81l7.1,4.4h13.5
					l4.5-4.4h29.4c3.3-0.1,6.4,1.7,7.9,4.7c1.5,2.9,4.6,4.8,7.9,4.6c1.9,0,3.8-0.6,5.4-1.7c1.1-0.8,2.4-1.2,3.7-1.2
					c3.2,0,5.8,2.2,5.8,5v3.4l-5.5,4.7v17l6.4-5.5v-8.9l5-4.3c1-0.9,2.2-1.3,3.5-1.3c2.6,0,4.7,1.8,4.7,4c0,0.3-0.1,0.5-0.1,0.8
					c-0.1,0.3-0.2,0.5-0.2,0.8c0,2,2,3.6,4.3,3.6l0.1,6.8h4.1l-5.1,4.4h9.9l9.3-7.8c2.6-2.6,6.2-4,9.9-3.9h23.9l7.3-6.2L417.3,214.1
					z"
                ></path>
                <polygon
                  class="st0"
                  points="266.8,11.1 259.1,17.6 259.1,23.1 270.4,23.1 270.4,26.3 266.2,30 273.6,30 280.8,23.8 292.9,23.8 
					297.5,27.8 307,19.7 302.4,15.8 296.3,15.8 296.3,9.9 292.6,9.9 286.8,14.9 281.1,14.9 276.7,11.1 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="258.7,35.1 243.8,35.1 230.5,46.5 230.5,51.4 222,51.4 222,56 209.7,45.5 209.7,39.5 213.6,36.2 
					213.6,32.2 224,23.2 238.1,23.2 243.1,27.6 249.8,27.6 				"
                ></polygon>
              </g>
              <polygon
                id="Taiwan"
                class="st0"
                points="1370.2,346 1369.7,348.3 1367.4,351.1 1368.1,355.5 1370.4,359.1 1371.6,359.4 
				1374.2,354.1 1373.7,352.1 1374,351 1375.2,350.2 1375.7,347.7 1374.3,344.1 1372.5,343.8 			"
              ></polygon>
              <polygon
                id="Portogallo"
                class="st0"
                points="744.6,277.7 743.5,278.6 736.7,278.6 736.7,268.5 734,269.5 736.8,251.8 
				743.3,251.8 746.4,250.7 747,253.1 748.8,254 745.6,256.4 746.4,259.8 745.2,261.2 746.1,263.7 743.6,264.5 745.6,266.8 
				744.4,270.6 746.1,272 744,275.4 			"
              ></polygon>
              <g id="Filippine">
                <polygon
                  class="st0"
                  points="1361.7,430.4 1361.7,424.6 1368.9,418.1 1368.9,414.2 1373.9,414.2 1373.9,418.9 1365.3,426.5 
					1365.3,429.3 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1383.8,402.2 1383.8,399.9 1389.1,399.9 1394,404.3 1390.8,407.2 1388.8,405.5 1386.3,405.5 				
					"
                ></polygon>
                <polygon
                  class="st0"
                  points="1394.2,411 1394.2,407.4 1399.7,407.4 1402.3,409.8 1402.3,416.5 1399.8,416.5 1399.8,412.9 
					1397.7,411 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1382.9,419.2 1382.9,412.6 1385.2,410.6 1388.9,413.9 1388.9,416 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1390.3,418.9 1388.2,418.9 1385.3,422.7 1385.3,424.4 1390.4,424.4 				"
                ></polygon>
                <path
                  class="st0"
                  d="M1390.3,428.2c0.5-0.6,1.2-0.9,1.9-0.9c0.5,0,1.1,0.2,1.5,0.5c0.4,0.3,0.9,0.4,1.4,0.4
					c0.6,0,1.2-0.2,1.7-0.6l4.6-4.2h4.4v9.6l2.7,2.5v4.7l-5.1-4.5h-3.4l5.9,6.3h-6.4l-4.5-4v-4.1h-2.8l-5.7,5.1h-4.1v-3.7
					L1390.3,428.2z"
                ></path>
                <path
                  class="st0"
                  d="M1381.9,408.6c-0.1,1.2-1.1,2.2-2.4,2.1c-0.8,0-1.5-0.4-2-1l-3.7-5.5h6.3l2,1.8L1381.9,408.6z"
                ></path>
                <path
                  class="st0"
                  d="M1376.2,377.2c-2-0.1-3.8,1.4-3.9,3.5l0.1,9.4l-3.2-2.8l-2.1,2l5.7,5v4l4.4,4h5.3V399l-3.1-2.8v-3.3
					l4.8-4.2v-5.8l-3.5-3.1l3-2.7l-2.8-2.5l-3.3,2.9L1376.2,377.2z"
                ></path>
              </g>
              <path
                id="Madagascar"
                class="st0"
                d="M991.4,593.1c0,1.1,1,2,2.1,1.9c0,0,0.1,0,0.1,0h2.1l1.9,1.7v2.8h3.4l2.5-2.2l2.6,2.3
				l7.2-6.4v-10.5l4.7-4.2v-12.2l4.2-3.7c0.9-0.8,1.3-1.9,1.3-3l-0.1-9.9l1.7-1.5l1.9,1.7l1.9-1.7l-4.2-3.8l3-2.7l-4.8-4.3v-6.7
				l-2.9,2.6v2.6c-0.1,1-1,1.7-1.9,1.6c-0.4-0.1-0.8-0.2-1.2-0.2c-2-0.1-3.8,1.4-3.9,3.5l0.1,4.1h-3.2l-4.2,3.8v2.3l-3-2.6h-4.4v2.5
				l-5.7,10.4l2.1,1.9v12.2l-5.9,7.3v3.8l2.5,2.2L991.4,593.1z"
              ></path>
              <g id="Australia">
                <polygon
                  class="st0"
                  points="1470.1,682.8 1474.9,682.8 1478.6,686.1 1481.9,686.1 1483.8,684.3 1488,684.3 1488,692.6 
					1484.8,692.6 1484.8,696.5 1478.3,702.4 1474.7,702.4 1471.4,699.4 1471.4,690.1 1469,687.9 				"
                ></polygon>
                <path
                  class="st0"
                  d="M1513.1,582.7c0.1,1.6,1.5,2.9,3.1,2.8h3.1v6.8l8.9,8l-3.6,3.2v10.5l3.6,3.2c0.5,0.4,0.8,1,0.8,1.7
					c0,0.6-0.2,1.2-0.7,1.6l-9,18.5h-3.5c-1.6-0.1-3,1.1-3.1,2.7c0,0,0,0,0,0v4.2l-5.8,5.1v5l-9,10.7h-4.4l-6.8,6.1h-6.7l-4-3.5
					h-3.4l-4.8,4.2l-4.1-3.6l-3.4,3l-9.1-8.1l4.4-4l-5.2-4.6h-5.8l4.3-3.8h-3.4v-5.1l5.6-5v-5l-15.1,13.5h-3.5V644l-4.8-4.3h-4.8
					l-5.7-5.1h-9.7l-3.8,3.5c-1.3,1.2-3,1.8-4.7,1.8h-10l-9.6,8.5h-19.3l-4.5,4h-11.5l-4.2-3.7l-5.5,0.2v-3.4l2-1.8h2.4l2.5-9.3
					l-2.3-1.5v-15.3l-3.7-3.3v-4.6l-2.9-2.6v-4.2l3.1-2.8l2.4-17.4h4.4l11-7.2h7.6l4.1-3.6l3.4,3.1l11.5-5.6l1.9-4.3v-7.9l4.2-3.8
					h2.9l-3.8,3.4l3.6,3.2l2.4-2.2v-4.2h3.1v-4.7l12.9-6.8c0.5-0.4,1.1-0.6,1.7-0.6c1.4-0.1,2.6,1,2.7,2.4v3.4h3.4l1.7-1.5h3.2v-2.6
					c0-1.2,0.5-2.4,1.4-3.2l4.1-3.6l9.3-2.1l-2.4-2.2v-3.9h4.5v2.8h11.7c1,0,2,0.4,2.7,1.1l1.7,1.6l3.2-2.8v6.9l-3.7,3.3v7.4
					l4.3,3.9h5.2l2.5,2.3c1.8,1.7,4.1,2.6,6.6,2.6c3.5,0.1,6.7-1.8,8.2-4.9l2.7-5.8l-1.9-5.3l5.7-17.1h2.7v6.4l2.8,2.5v9.5h3.8
					c1.2-0.1,2.2,0.8,2.2,2c0,0,0,0,0,0v10.4l3.8,3.4v8.4c0,0.9,0.4,1.7,1.2,2.2l6.5,4c1.8,1.1,3,2.9,3.6,4.9L1513.1,582.7z"
                ></path>
              </g>
              <g id="Giappone">
                <polygon
                  class="st0"
                  points="1478.3,232.4 1484.7,232.4 1484.7,225.9 1481.3,225.9 1481.3,229.1 				"
                ></polygon>
                <path
                  class="st0"
                  d="M1459.7,271.1c-0.4-0.1-0.7-0.5-0.8-1c0-0.3,0.1-0.6,0.4-0.8l2.5-2.1v-7.8l-4.9-4.4v-8.5l-4.5,4v5.7
					l-3.2,2.8c-0.2,0.2-0.4,0.5-0.4,0.8c0,0.4,0.2,0.7,0.5,0.9l2.3,2v5.3c0,1.1-0.4,2.1-1.3,2.9l-6.6,5.8l-2.5-2.3
					c-0.4-0.6-1.3-0.7-1.9-0.3c-0.1,0.1-0.2,0.2-0.3,0.3l-4.6,9.1h-10.2c-1.4-0.1-2.5,1-2.6,2.3v1.4l-3.6,3.2
					c-0.2,0.2-0.4,0.5-0.4,0.8c0,0.4,0.2,0.7,0.6,0.9l2.6,2.4l4.3-3.9h9.3l5.7,5h3.2v-8.5l3.5,3.1l4-3.7c1-1.1,2.7-1.2,3.9-0.2
					l0.6,0.5l3.3-3l2.8,2.5l2.5-2.2l-4.2-3.7c-0.6-0.4-1-1.1-1-1.8c0-0.8,0.4-1.5,1.1-1.9l3.1-2.7L1459.7,271.1z"
                ></path>
                <path
                  class="st0"
                  d="M1462.9,247.3c0.1-1.6,1.4-2.8,3-2.7h4.1l5-4.5v-2.5c-0.1-1.6-1.4-2.8-3-2.7c0,0,0,0,0,0l-2.7-0.1l-3.2,2.8
					l-7.5-6.7h-3.6c-1.6-0.1-3,1.1-3.1,2.7v4.4l-6.2,5.5l4.8,4.3l5.3-4.8l6.8,6.1L1462.9,247.3z"
                ></path>
                <path
                  class="st0"
                  d="M1415.2,307l3.6,3.3c0.4,0.4,0.9,0.6,1.5,0.6c1.1,0.1,2.1-0.8,2.2-1.9v-3c0-1.6,0.7-3.1,1.9-4.1l1.9-1.9
					c0.2-0.2,0.4-0.5,0.4-0.8c0-0.3-0.2-0.6-0.4-0.9l-2.4-2.1h-13.3v3.9l3.4-0.1c0.7,0,1.2,0.5,1.2,1.1L1415.2,307z"
                ></path>
              </g>
              <polygon
                id="Germania"
                class="st0"
                points="833.9,202 833.9,200.8 835.7,200.8 835.7,199.2 838.3,199.2 842.6,195.9 846.2,195.3 
				844.3,192.1 843.4,187.9 841.2,185.9 841,185 841.9,184 841.1,180.4 838.8,180.1 838.8,178.1 834,176.6 832.7,178.2 829.5,178.8 
				817.8,173.7 817.8,176.4 819.6,176.9 819.6,181.1 813.1,184.5 812.1,188 810.2,188.3 811.8,190.5 810.8,192.4 809.1,193.5 
				807.1,192.9 807.8,196.1 806.8,197.2 807.3,199.5 808.6,200.2 808.9,201.7 807.7,203.1 808.5,207 810.9,209.5 816.9,209.5 
				814.8,213 814.2,217.2 815.9,218.4 821.3,217.5 823.8,219.2 824.1,217.8 826.1,219.1 827.7,217.6 831.9,217.6 833.9,216.4 
				835.1,217 837.5,215.5 839.4,216.6 839.4,214.7 838.3,213.5 839,212.2 840.2,211.9 840.8,210.4 842.8,211.1 842.8,210.2 
				842.8,209.1 839.1,207.8 839.1,206.3 835.7,204.4 835.7,202 			"
              ></polygon>
              <polygon
                id="slovenia"
                class="st0"
                points="843.1,227.2 844,228.1 845.1,228.2 845.6,227.8 847.6,227.8 847.6,227.3 848.4,227.3 
				849,228.1 849.6,228.1 850.9,228.7 851.6,228.1 851.6,227.1 853.2,226.4 853.3,224.8 855.5,223.7 856.3,223.7 856.3,223 
				857.5,223 855.3,221.4 854.3,222.4 851.8,222.4 851.1,221.6 850,222.6 847.4,223.2 845.9,222.2 843.3,222.7 842.2,224.8 
				843.1,225.3 			"
              ></polygon>
              <polygon
                id="Albania"
                class="st0"
                points="872.3,262.5 872.3,260.8 870.6,259.7 870.6,251.7 870.1,247.9 871.6,247.2 
				871.6,245.8 872.9,245.8 873.8,247.2 875.4,247.2 876.4,246.4 877.4,246.4 877.4,247.7 878.9,248.8 878.9,251.3 877.6,253.6 
				878.7,256.3 881.1,256.9 881.1,259.3 879,261.6 877.5,261.6 877.5,263.7 876,264.1 			"
              ></polygon>
              <polygon
                id="Croazia"
                class="st0"
                points="843.1,227.2 844,228.1 845.1,228.2 845.6,227.8 847.6,227.8 847.6,227.3 848.4,227.3 
				849,228.1 849.6,228.1 850.9,228.7 851.6,228.1 851.6,227.1 853.2,226.4 853.3,224.8 855.5,223.7 856.3,223.7 856.3,223 
				857.5,223 858.3,223.6 858.6,225.6 863.6,228.3 867,228.4 867.2,230.3 868.8,231.4 868.8,232 867.2,231.7 867.2,233.4 
				865.8,233.4 865.8,232.3 860.8,232.2 857.7,230.8 855.4,230.7 854.3,232 853,230.7 852.3,230.7 851.8,231.4 851.7,232.3 
				853.5,235.1 853.5,236.4 858.6,240.5 860,240.5 860.1,241.7 864.8,245.8 852.9,240.6 847.9,231.7 845.3,231.2 843.2,233 
				841.5,228.6 843.1,228.6 			"
              ></polygon>
              <polygon
                id="Olanda"
                class="st0"
                points="807.3,199.5 806.1,199.5 805.6,197.5 803.2,195.9 799.8,196.6 800.1,197.6 795.2,196.5 
				792.1,197.3 792.6,199.6 794.9,200.1 795.3,201.9 798.2,202.5 798.7,204.6 799.9,204.4 800.7,203.4 801.7,203.2 802,204.8 
				804,205.9 805.8,205.6 806.6,203.3 807.7,203.1 808.9,201.7 808.6,200.2 			"
              ></polygon>
              <polygon
                id="Netherlands"
                class="st0"
                points="795.2,196.5 798,196 801.6,186.9 809.5,183.8 811.3,184.7 812.9,184.4 812.1,188 
				810.2,188.3 811.8,190.5 810.8,192.4 809.1,193.5 807.1,192.9 807.8,196.1 806.8,197.2 807.3,199.5 806.1,199.5 805.6,197.5 
				803.2,195.9 799.8,196.6 800.1,197.6 			"
              ></polygon>
              <polygon
                id="Austria"
                class="st0"
                points="854.6,219.1 854.6,218.2 856.2,217.9 855,213.5 856.6,213.4 857.4,214 858.5,214 
				858.2,211.6 856.9,211.1 856.3,208.2 853.9,207.7 853.2,208.6 847.7,207.1 847.7,208.3 845.2,210.3 842.8,210.2 842.8,211.1 
				840.8,210.4 840.2,211.9 839,212.2 838.2,213.6 839.4,214.7 839.4,216.6 837.4,215.5 835.1,217 833.9,216.4 831.8,217.7 
				827.7,217.7 826.1,219.1 824.1,217.8 823.8,219.2 823.8,219.2 824.2,221.6 826,221.2 827.5,221.9 828.9,221.9 831.1,221.6 
				832.1,220.4 834.2,220 834.2,219 835.9,218.9 836.8,219.7 836.3,221.3 837.9,222.1 839.6,221.7 843.3,222.7 845.9,222.2 
				847.4,223.2 850.3,222.6 851.1,221.6 851.8,222.4 			"
              ></polygon>
              <g id="Danimarca">
                <polygon
                  class="st0"
                  points="817.9,162.6 821.9,161.6 823.7,161.9 824.2,160.8 824.3,157.7 822,158.7 821.2,160.9 817.2,161.8 
					816.2,163.6 817,164 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="817.8,173.7 821.4,175.1 821.4,170.7 825.9,167 825.8,165.5 823.2,162.5 816.1,167.8 816,171.6 
					817.8,171.1 				"
                ></polygon>
              </g>
              <polygon
                id="Svizzera"
                class="st0"
                points="823.8,219.2 824.2,221.6 826.1,221.2 827.5,221.8 825.8,223.8 826.5,224.7 
				823.3,225.4 822.2,224.5 820.8,228 820.5,226.5 819.3,226.5 818.3,224.9 816.7,227.2 812.4,228 810.3,226.7 810,225.4 
				808.7,225.4 807.4,226.2 807.5,227.3 806.3,227.3 806,225.8 808.6,223.7 808.7,222.4 811.6,219.9 811.2,219.2 811.8,218.2 
				812.8,218.5 814.2,217.2 815.9,218.4 821.3,217.5 			"
              ></polygon>
              <polygon
                id="Irlanda"
                class="st0"
                points="736.7,182.5 742.6,180.7 742.6,178.4 737.1,176.1 737.1,171.5 742.6,171.4 
				742.6,168.8 750.8,165.5 755.2,169.2 751.3,182.6 736.7,187.6 			"
              ></polygon>
              <path
                id="Spagna"
                class="st0"
                d="M791.8,248.4v5.9H788c-2,0-3.9,0.8-5.2,2.3l-4.8,5.1l0.5,3.4l2.3-0.1l0.4,0.9l-3.2,2.4l-1.5,4.6
				l-2.3,0.5l-0.8,1.5c-1.2,2.4-3.7,3.9-6.4,3.8h-6.5l-6.5,4.8l-6.2-6l-2.9,0.3l-0.6-2.4l2.1-3.4l-1.7-1.4l1.2-3.8l-2-2.4l2.5-0.8
				l-0.9-2.5l1.2-1.4l-0.8-3.4l3.2-2.3l-1.7-1l-0.6-2.4l-3.1,1.1h-6.6l0.1-3.9l-2.8-1.3l6.5-4.3h26.7l11.7,5.5l1-1.6h3.8l0.7,2.2
				L791.8,248.4z"
              ></path>
              <g id="Francia">
                <polygon
                  class="st0"
                  points="818.9,245.5 818.9,250.5 822.5,253.1 824.2,248 824.2,243.5 823.2,243.5 823.2,245.5 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="770.8,211.5 767.1,211.5 764.5,209.4 757.6,210.7 757.6,215.3 760.7,214.8 767.8,217.9 
					767.8,222.1 774.6,233.3 770.3,234.6 769.3,240.4 767.2,242.3 778.9,247.8 779.9,246.2 783.7,246.2 784.4,248.4 791.8,248.4 
					792.4,244.4 797.2,242.2 803.1,243.4 806.7,244.9 810.2,244.2 812.1,241.8 816.9,239.9 815.8,239.2 816.6,237.4 813.1,237.4 
					811.2,235.3 812,234.8 810.5,232.6 812.4,231.9 812.6,230.6 811.3,229.8 811.1,228.6 812.4,228 810.3,226.7 810,225.4 
					808.7,225.4 807.4,226.2 807.5,227.3 806.3,227.3 806,225.8 808.6,223.7 808.7,222.4 811.6,219.9 811.2,219.2 811.8,218.2 
					812.8,218.5 814.2,217.2 814.8,213 816.9,209.5 810.9,209.5 808.6,206.9 807.2,207.1 805.8,205.6 804,205.9 802,204.8 
					801.7,203.2 800.7,203.4 799.9,204.4 798.7,204.6 798.2,202.5 795.3,201.9 794.9,200.1 792.6,199.6 792.1,197.3 788,198.5 
					785.6,203.3 782.1,204.2 780.6,207.3 774.2,207.3 773.7,205.4 770.8,204.6 				"
                ></polygon>
              </g>
              <polygon
                id="Hutan"
                class="st0"
                points="1211.8,325.5 1216.3,321.4 1219.7,321.4 1224,325.3 1226.8,325.3 1226.8,332.4 
				1215.7,332.4 1211.8,328.9 			"
              ></polygon>
              <path
                id="Vietnam"
                class="st0"
                d="M1314.7,360.7l-5,0.1c-3.3,0.1-6.3-2-7.3-5.1c-0.5-1.7-2-2.8-3.8-2.8h-4.4l-2.9-2.6l-5.5,4.9
				h-5.4l3.5,3.1v4.6h4.1l3.4,3v5.5l2.6,2.4v3.7l7.1,6.4v4l7.9,7l-2.1,2l0.1,8.5l-5.9,5.3v2.3c-0.1,1.4-1.2,2.4-2.6,2.3h-3.4
				l-2.8,2.5l6.2,5.6v2.9l5.6-1.7c1.7-0.3,2.9-1.7,3-3.4v-1.9l3.4-3h5.3l5.3-4.7l-3-2.7v-12.4l-6.8-6.1v-2.3c0-1.3-1.4-2.3-2.9-2.3
				s-2.9-1-2.9-2.3v-2.2l-5.6-5V372l3.5-3.1h2.7L1314.7,360.7z"
              ></path>
              <path
                id="Laos"
                class="st0"
                d="M1306.8,396.6l2.1-2l-7.9-7v-4l-7.1-6.4v-3.7l-2.6-2.4v-5.5l-3.4-3h-4.1v-4.6l-3.5-3.1h-2.6v5.4
				l-4.1,3.7l-3.1-2.8v9l3.2,2.8v2.2c0.1,1.4,1.3,2.4,2.6,2.3h4.4l3,2.6l2.4-2.2c0.5-0.6,1.2-0.9,2-0.9c0.7,0,1.3,0.2,1.8,0.7
				l5.2,4.7v3.9l5.1,4.6l-1.7,5.6L1306.8,396.6z"
              ></path>
              <path
                id="Cambogia"
                class="st0"
                d="M1298.4,396.7h8.5v8.5l-5.9,5.3v2.3c-0.1,1.4-1.2,2.4-2.6,2.3h-3.4l-2.8,2.5V414l-5-4.7v-3
				l-1.8-1.7v-5.8c0.1-1.4,1.2-2.4,2.6-2.3c0,0,0,0,0,0h2.3l4.2,3.8L1298.4,396.7z"
              ></path>
              <path
                id="Mongolia"
                class="st0"
                d="M1191.1,208.9v-4.5h4.8c1,0.1,1.9-0.7,1.9-1.7c0,0,0,0,0,0v-6.4h3.6l1.9,3h2.7l1.5-5.1h2.5
				l2.1,1.9h3.6c1-0.1,1.9,0.7,1.9,1.7c0,0,0,0,0,0l-0.1,2.5l10.3-0.6l6.5,1.7l1.5-3.4l-3.8-3.2v-2.6h2.5v-5.5h2.4l4.7,4.2h8.1
				l4.4,3.9v3.9l12.7,2.3l3.6-2.8l6.3,4.1l3.2-1.1l4.3,3.9l11.3,2l2.4-2.2h10v-3.3l4-3.6h2.5v3h3.2l2.4-2l5.9,3.8l-6.1,5.5v7h4.4
				l1.7,1.5h3.6l2.5-5.5h3.6v4.1l7.4,2.3v2.6h-12.3l-2.6,2.3v2.9l-3.3,2.9h-5.9v3.3h-6.2l-2.2-2h-3.8v4.3l3.1,2.7l-2.6,2.4h-3.2v3.9
				l-4.8,4.3h-7.8c-1.6,0-3.2,0.6-4.3,1.8l-3.6,3.2h-10.1l-6.3-5.6l-2.7,2.4l-4.4-3.9h-8.6l-6.2,2.2l-2.2-2l-13.9-4v-6.8h-3.2
				l-3-2.6l-14.6,0.1c-1.8,0.1-3.3-1.2-3.3-3c0-0.8,0.4-1.6,1-2.1l1.1-1v-2.4l-2.8-2.5v-3.8h-3v-3.5h-2.4l-2.2,2h-3.4v-4.9
				L1191.1,208.9z"
              ></path>
              <path
                id="Corea_del_nord"
                class="st0"
                d="M1400.4,246.3v11.3h-2.3c-1.9-0.1-3.5,1.3-3.7,3.2v2.7h-5.3v3l3.5,2l-4.5,3.2l-1.4-1.2
				h-3.1l-3.6,3.2h-2.4v-4l1.4-1.2c0.7-0.7,0.7-1.8,0.1-2.5c-0.3-0.3-0.8-0.5-1.2-0.5h-5.9v-2.1l4.2-3.8c0.9-0.8,1.4-1.9,1.4-3.1
				v-2.4l2.7-2.5v-1.4c0-1.2,1.1-2.2,2.3-2.1c0,0,0,0,0,0h1.6l4.4,4l1.6-1.4c0.5-0.8,1.4-1.2,2.4-1.2l1.9,0.1v-5.9h2.7L1400.4,246.3
				"
              ></path>
              <path
                id="corea_del_sud"
                class="st0"
                d="M1380.2,273.7v2.6h4.4c1.3-0.1,2.5,0.9,2.7,2.2c0,0.5-0.2,1.1-0.6,1.5l-1.7,1.5v1.7h1.6
				c1,0,1.9,0.8,2,1.8v4l-2.4,2.2l1.4,1.2h2.5l1.6-1.4h4.1l1.5-1.4l3.4,3.1v-3.8c0-0.7,0.7-1.3,1.4-1.3h1.2l-1.5-9.8l-4.3-2.7
				c-1.1-0.6-1.8-1.8-1.9-3.1l0.1-1.8l-3-1.6l-4.5,3.2l-1.4-1.2h-3.1L1380.2,273.7z"
              ></path>
              <path
                id="China"
                class="st0"
                d="M1244.6,320.6c0.1,1.4,1.2,2.4,2.6,2.3h5.2l7.1,6.4v6l-2.9,2.6l-0.1,5.5c0.1,2,1.8,3.6,3.9,3.5
				c1.7,0.3,2.9,1.7,3,3.4c0.4,1.1,1.4,1.8,2.6,1.7h2.1v7.2l5.7,5l4.1-3.7v-5.4h8l5.5-4.9l2.9,2.6h4.4c1.8-0.1,3.3,1.1,3.8,2.8
				c1,3.2,4,5.3,7.3,5.1h6v4.9l3.7,3.3l2.4-2.1v-4.4l10,0.2c3.2,0.1,6.1-2,6.8-5.2c0.1-2,1.9-3.5,3.9-3.4h4.7l5-4.4l9.8-8.7v-9.8
				h5.1v-5.5h3.1V321l-3-2.7c-0.9-0.9-1.5-2.1-1.5-3.4c0-1.3,0.6-2.6,1.6-3.5c2.2-1.8,2.6-5,0.8-7.3c-0.2-0.3-0.4-0.5-0.7-0.7
				l-5.4-4.7v-6.1h-5.9l-3.7-3.3l4.7-4.2h3.6v-3.8h5.7v-6.6h-18.5l-5.4-4.8l6.4-5.8h4.6l5-4.4h4.5l-4.5,4l2.4,2.1h4.2l2.7-2.5h4.4
				l4.2-3.8c0.9-0.8,1.4-1.9,1.4-3.1v-2.4l2.7-2.5v-1.4c0-1.2,1.1-2.2,2.3-2.1c0,0,0,0,0,0h1.6l4.4,4l1.6-1.4
				c0.5-0.8,1.4-1.2,2.4-1.2l1.9,0.1v-5.9l3,0.1l4.1-4.8l-3.8-4.7l-0.2-3.6h3.2l2.5,4.1l2.1-1.1l1-6.8l4-1.7l-2.5-7l3.6-8.3h-4
				l-3,4.9l-13.3-1.5l0.2-5.5l-2.7-0.9l-3.2,2.2l-3.4-2.2v-2.6h-8.3v-3.9l-2-1.8v-4.9l-7.6-6l-4.2-7.9l-7.8,3.2l-8.6-3.2l-9.1,4.1
				v2.4l3.7,0.2v4.2l-2.8,2.6l0.2,8.5l-6.3,2.6l-3.8-1.7l-6.1,5.5v7h4.4l1.7,1.5h3.6l2.5-5.5h3.6v4.1l7.4,2.3v2.6h-12.3l-2.6,2.3
				v2.9l-3.3,2.9h-5.9v3.3h-6.2l-2.2-2h-3.8v4.4l3.1,2.7l-2.6,2.4h-3.2v3.9l-4.8,4.3h-7.8c-1.6,0-3.2,0.6-4.3,1.8l-3.6,3.2h-10.1
				l-6.3-5.6l-2.7,2.4l-4.4-3.9h-8.6l-6.2,2.2l-2.2-2l-13.9-4v-6.8h-3.2l-3-2.6l-14.6,0.1c-1.8,0.1-3.3-1.2-3.3-3
				c0-0.8,0.4-1.6,1-2.1l1.1-1v-2.4l-2.8-2.5v-3.8h-3v-3.5h-2.4l-2.2,2h-3.4v-4.9l-2.1-1.9h-5.3c-1,0-1.9,0.7-1.9,1.7v1.7h-8.9v2.3
				l4.8,4.3l-3.6,3.2l-3.3-3h-2.7v7.7l-4,3.6h-4c-1-0.1-1.8,0.7-1.9,1.7c0,0,0,0,0,0v5l-2.6,2.4c-0.7,0.6-0.8,1.6-0.2,2.3
				c0.1,0.1,0.2,0.2,0.3,0.3l1.6,1.5v3.8c-0.1,1-0.9,1.8-1.9,1.7h-2.7l-5.7,5.1h-4.4c-1-0.1-1.9,0.7-1.9,1.7c0,0,0,0,0,0v2.2
				l-2.5,2.1l-4.4-4l-4.8,4.3l-0.4,4.8l4.6,0.1l2.7,2.3l-0.1,6.8h4l3.2,2.8v1.3c0.1,1,0.9,1.8,1.9,1.7h1.9l2.8,5.1h2.7v-2.8l9.4,1.7
				v4.4l-3,2.7v5.4l2.5,2.2c0.5,0.4,0.7,1,0.7,1.6c-0.1,1.3-1.2,2.3-2.5,2.2h-0.8c-1.6-0.2-3,1-3.2,2.6c-0.2,1.6,1,3,2.6,3.2
				c0.2,0,0.4,0,0.6,0h3.2l3.6,3.2h9.7l6.5,5.9c0.4,0.3,0.9,0.5,1.4,0.5c0.6,0,1.2-0.2,1.6-0.6l1.9-1.8v3.9h3.6l6.8,6.1h12.9l4.5-4
				h3.4l4.3,3.8h7.3c1.4,0.1,2.5-1,2.6-2.3v-3.5l7.2-6.4l3.4,3.1L1244.6,320.6z"
              ></path>
              <polygon
                id="Sri_Lanka"
                class="st0"
                points="1175.5,438.7 1175.5,441.1 1177.4,442.8 1184,437.3 1184,430 1181.2,427.5 
				1179.3,427.5 1179.3,423.2 1177.4,423.2 1173.6,428.9 			"
              ></polygon>
              <path
                id="Afganistan"
                class="st0"
                d="M1078.4,318.5l-5.5-4.9l3.3-2.9l-6.8-6.1v-4.3l2-1.8l-3.4-3c-0.6-0.7-1-1.6-1-2.5
				c0-1.1,0.5-2.2,1.3-2.9l3.6-3.3h5.2l2.3,2.3l5-4.5v-3.4h2.9v-4.7l6-5.4v3.3h7.2l2.9,2.8l2.6-2.4h4.4l5.8-5.3h3.2l-2.8,2.5h4.7
				v6.1l3.6-3.1l3.4,2.9l-5.5,5.3v2.1l2,1.8v5.9l-5,1.5c-1.2,0.3-2.1,1.3-2.2,2.6l-0.1,2.1l-3.8,3.4v3.8h-6c-1.2,0-2.4,0.7-2.8,1.8
				c-0.4,1.3-1.7,2.1-3,2h-0.6l-8.3,8.6L1078.4,318.5z"
              ></path>
              <path
                id="Svezia"
                class="st0"
                d="M827,137.4v10.9l3.6,3.2v3.1c0,1.2,0.6,2.3,1.5,3.1l3.2,2.8v4.9h1.9v3.8h2.3l4.3-3.9v-3.1h3.4
				c1.5,0.1,2.7-1.1,2.8-2.5v-3.9l7.4-10.7v-3.2c0.1-1.3,1.2-2.3,2.5-2.3h0.6l2.8-2.5v-3.3H859l-2.7-2.4v-4.7l4.2-9.2h3.4L874,108
				v-2.3h-3.8l7.2-8.3h1.6v-14l-2.3-2.1l2.2-2v-3.5h-5.2l-5.3-4.8l0.1,3h-4.2l-7.2,6.4v6h-4.2l-6.5,5.8c-0.9,0.7-1.5,1.8-1.5,3v4
				l-5.5,4.9V120c0,1.1-0.7,2-1.7,2.2c-1.3-0.1-2.4,1-2.5,2.3c0,0,0,0.1,0,0.1v0.9c0,1.7-0.8,3.3-2.2,4.4l-2.3,2.1v8.6L827,137.4z"
              ></path>
              <path
                id="Finlandia"
                class="st0"
                d="M904.1,128.9l-7,6.2h-6.3l-3.6,3.2l-2.3-2.1h-9v-2.9l-3-2.7v-11.9l6.1-5.5v-3h5.4v-3.5
				l4.5-4.1v-2.4l-3.2-2.8h-6.8v-14l-2.3-2.1l2.2-2v-3.5h-5.2l-5.4-4.8h5l4.4,4l1.5-1.3l3,2.6h3.8l4.4-4v-4.3l3.1-2.8h5.9l2.3,2V73
				l2,1.8v3.1l4.7,4.2v3.2l-1.3,1.1c-0.7,0.6-0.8,1.7-0.2,2.4c0.1,0.1,0.1,0.1,0.2,0.2l3.4,3v4.5L909,98v4.6l3,2.7v5.8l2.3,2.6
				c1.2,1,1.4,2.8,0.4,4.1c-0.1,0.1-0.2,0.2-0.3,0.3l-3.2,3.4v3.9H908L904.1,128.9z"
              ></path>
              <path
                id="Norvegia"
                class="st0"
                d="M901.7,73h3.2l2.8-2.5v-8.2l-8.5-5.3h-3.4l-24.2,10.7h-7.2l-7.6,4.3v4l-6.3,5.7h-5.3l0.1,4.2
				L833.8,96v6H830v2.8l-17.9,13.4h-3.8l-8.2,8.5v5.6l3.3,2.7v12l5,4.2h7.3l8-6.9v-4l3.4-3l3.7,3.3v-8.6l2.3-2.1
				c1.4-1.1,2.2-2.7,2.2-4.4v-0.9c0-1.3,1-2.4,2.3-2.4c0,0,0.1,0,0.1,0c1-0.2,1.7-1.2,1.7-2.2v-15.9l5.5-4.9v-4c0-1.2,0.6-2.3,1.5-3
				l6.5-5.8h4.2v-6l7.2-6.4h4.2l-0.1-3h4.9l4.4,4l1.5-1.3l3,2.6h3.8l4.4-4v-4.5l3.1-2.8h5.9l2.3,2L901.7,73z"
              ></path>
              <polygon
                id="Libano"
                class="st0"
                points="950.7,292.2 947.2,295.4 947.2,305.8 949.7,300.2 949.7,297.3 953.8,295.2 953.8,292.2 
							"
              ></polygon>
              <polygon
                id="Rep_Ceca"
                class="st0"
                points="856.3,208.2 853.9,207.7 853.2,208.6 847.7,207.1 847.7,208.3 845.2,210.3 
				842.8,210.2 842.8,209.1 839.1,207.8 839.1,206.2 835.7,204.4 835.7,202 833.9,202 833.9,200.8 835.7,200.8 835.7,199.2 
				838.3,199.2 842.6,195.8 846.2,195.3 852,197.2 852,198.3 855.2,198.8 855,197.2 856.2,197.2 859.1,199.7 			"
              ></polygon>
              <polygon
                id="Slovacchia"
                class="st0"
                points="859.1,199.7 863.3,199.9 864.1,201.8 866.3,201.8 866.8,200.1 868.5,200.4 
				868.8,201.8 872,201.8 873,200.2 881.9,200.1 881.9,202 886.2,200.6 886.2,203.5 882.6,204.1 880.3,206.1 879.2,205.5 
				878.5,206.2 876.7,205.5 873.5,208.7 870.1,208.7 869,210.7 865,210.7 865,212.9 860.7,212.9 856.9,211.1 856.3,208.2 			"
              ></polygon>
              <polygon
                id="Polonia"
                class="st0"
                points="846.2,195.3 852,197.2 852,198.3 855.2,198.8 855,197.2 856.2,197.2 859.1,199.7 
				863.3,199.9 864.1,201.8 866.3,201.8 866.8,200.1 868.5,200.4 868.8,201.8 872,201.8 873,200.2 881.9,200.1 881.9,202 
				886.2,200.6 886.2,198.8 889.8,195.3 887.5,192.2 891.8,189.6 889.3,187.3 889.3,180.9 882.9,180.9 882.9,175.7 878.5,171.7 
				876.3,173.8 872.7,173.8 868.8,176.8 864.7,176.8 864.7,171.8 861.9,171.8 859.2,174.2 854.9,174.2 852.5,176.4 848.2,176.4 
				841.1,180.4 841.9,184 841,185 841.2,185.9 843.4,187.9 844.3,192.1 			"
              ></polygon>
              <polygon
                id="Romania"
                class="st0"
                points="889.8,212.5 889.8,215.6 886.9,216.6 885.6,219.3 884.3,219.8 884.3,221.5 
				881.2,225.4 879.6,225.4 878.2,226.7 881.1,231.2 882.7,231.2 883.3,234.2 886.8,235.7 886.8,234 889.4,234.9 888.6,236.4 
				889.8,237.6 893,239.8 903.5,239.8 907.3,237.5 909.7,237.5 914.7,241.5 914.7,234.1 909.7,234.1 909.6,229.7 907.5,227.1 
				907.6,218.4 909.9,216.3 909.9,211.2 901.5,211.2 901.5,209.1 899,209.1 895.1,212.5 			"
              ></polygon>
              <polygon
                id="Serbia"
                class="st0"
                points="870.6,251.7 864.8,245.8 860.1,241.7 860.1,240.5 858.6,240.5 853.5,236.4 853.5,235.1 
				851.7,232.3 851.8,231.4 852.3,230.7 853,230.7 854.3,232 855.4,230.7 857.7,230.8 860.8,232.2 865.8,232.3 865.8,233.4 
				867.1,233.4 867.2,231.7 868.7,231.9 868.7,231.3 867.2,230.3 867,228.4 870.7,226.1 872.3,225.6 874.2,226.6 876,226 
				878.1,226.5 881.1,231.2 882.7,231.2 883.3,234.2 886.8,235.5 886.8,234 889.4,234.9 888.6,236.2 889.8,237.4 888,238.8 
				889.2,241.5 891.1,243.4 889,245.6 888.9,247.5 887.8,248.4 890.7,250.6 891.4,253.9 891.4,253.9 888.4,255.2 885.5,255.2 
				885.4,256.9 881.1,256.9 878.7,256.3 877.6,253.6 878.9,251.3 877.4,247.7 877.4,246.5 876.4,246.4 875.4,247.3 873.8,247.2 
				872.9,245.8 871.6,245.8 871.6,247.2 870.1,247.9 			"
              ></polygon>
              <g id="Grecia">
                <polygon
                  class="st0"
                  points="894.2,268.2 895.7,267.1 897.1,268.2 898.2,268.2 900.7,269.7 901.7,272 903.2,272 903.2,273 
					901.7,273 899.4,270.4 897.8,270.4 896.6,268.9 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="900,253 899.4,251.9 896.9,251.9 896.1,252.9 891.4,253.9 888.4,255.2 885.5,255.2 885.5,256.9 
					881.1,256.9 881.1,259.3 879,261.6 877.5,261.6 877.5,263.7 876,264.1 880.1,269.6 881.4,269.6 882.2,272 887.7,270.9 
					893.2,272.6 892,274 886.5,272 885.9,272.9 882.3,274.3 883,275.8 884.5,276.2 885.5,278.1 884.7,278.8 885.7,280.4 887,281.1 
					887,279.4 889,280.8 889,282.5 890.6,283.1 890.6,281.4 891.4,280.8 892.4,282 893.6,282.4 893.6,280.4 891.1,276.5 
					891.7,275.6 894.5,277.6 895.8,276.6 893.4,274.8 896,272.9 896,274.3 899.2,274.6 898.1,271.6 890.3,268 892.2,268 
					892.2,266.4 894.3,265.8 890.2,262.2 890.2,259.5 892.8,262.3 895.6,262.3 893.4,260.7 900.9,260.7 898.8,258.9 896.3,258.9 
					896.3,257.1 898.3,257.1 899.7,255.9 910.1,256 907.4,253.4 903.8,253.4 902.9,252.6 				"
                ></polygon>
              </g>
              <polygon
                id="Bulgaria"
                class="st0"
                points="891.4,253.9 891.4,253.9 890.6,250.6 887.8,248.4 888.9,247.5 889,245.6 891.1,243.4 
				889.2,241.5 888,238.8 889.8,237.6 893,239.8 903.5,239.8 907.3,237.5 909.7,237.5 915,241.5 911.9,244.3 909.6,244.3 909.6,248 
				912.4,248 914.4,249.8 914.4,253.8 912.6,253.8 910.1,256 907.4,253.4 903.8,253.4 902.9,252.6 900,253 899.4,251.9 896.9,251.9 
				896.1,252.9 			"
              ></polygon>
              <g id="Turchia">
                <polygon
                  class="st0"
                  points="986.4,259.5 986.4,253.2 978.1,253.2 975.2,250.1 970.4,254.1 950.2,254.1 945.6,249.9 
					933.3,249.9 928.9,253.9 922.7,253.9 920.7,255.6 910.4,255.6 902.5,262.8 908.2,267.9 908.2,275.9 911.9,279.2 911.9,282.4 
					914.6,282.4 916.5,280.5 922.4,280.5 929,277 934.6,282.1 938.7,282.1 941,280.1 947.3,280.1 950.7,283.1 954.5,279.7 
					966.6,279.7 969.6,276.9 991,276.9 991,268.8 986.4,264.7 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="908.7,250.2 914.4,249.8 914.4,253.8 912.6,253.8 910.1,256 907.4,253.4 				"
                ></polygon>
              </g>
              <polygon
                id="Ungheria"
                class="st0"
                points="854.3,222.4 855.3,221.4 858.3,223.6 858.6,225.6 863.6,228.3 867,228.4 870.7,226.1 
				872.3,225.6 874.2,226.6 876,226 878.1,226.6 879.6,225.4 881.2,225.4 884.3,221.5 884.3,219.8 885.6,219.3 886.9,216.6 
				889.8,215.6 889.8,212.5 887.2,212.5 883.5,209.2 880.3,209.2 880.3,206.1 879.2,205.5 878.5,206.2 876.7,205.5 873.5,208.7 
				870.1,208.7 869,210.7 865,210.7 865,212.9 860.7,212.9 858.2,211.6 858.5,214 857.4,214 856.6,213.4 855,213.5 856.2,217.9 
				854.6,218.2 854.6,219.1 851.8,222.4 			"
              ></polygon>
              <g id="Russia">
                <path
                  class="st0"
                  d="M1455.1,225c-0.6,0.5-1.4,0.8-2.2,0.8c-0.6,0-1.2-0.2-1.7-0.5l-3.6-2.7l0.1-17.5c0-2.4-1.1-4.7-3-6.3
					l-5.6-4.8v-9.2l3.3-3v-8h3.2v7.3l2.5,2.2v8l8.1,12.9l4.5,4v2.7l-3.1-0.1c-1.6-0.1-3,1.1-3.1,2.7c0,1,0.6,1.9,1.4,2.3l4.8,4.3
					v3.3h-4L1455.1,225z"
                ></path>
                <path
                  class="st0"
                  d="M901.7,73h3.2l2.7-2.5l0,0c0.3,0.6,0.9,1,1.5,1c0.5,0,1-0.3,1.3-0.6l4.4-3.9h4.4v3.2l17.3,6.6h3.9
					c1.5,0,10.4,7.5,10.4,7.5h2.8v5.2l-3.7,3.3h-2.1l-4.4,2.6l-8.8-4.6H925l-5.2-4.6l-2.1,1.9v2.1h2.3l3.2,3v2.8h5.7v3.7l7.7,6.9h12
					l-10.3-9.2h5.9l7.4,6.7h6l-4.6-4.1v-7h6.8l2.6-2.3c0.7-0.6,4.9-0.6,5.6,0l3.9,3.5v-6.9l-3.6-3.2V67l9.9,8.9v8.6l3.8,3.4l4.5-4
					h5.1v-4.5l16.3-4.9c0.5-0.2,7.4,3.2,7.4,3.2l5.7-5.1h9.7l4.6,4.1h6.8l14-8.9l14.7,13.2h3.8v-6.1l-9.8-8.9l0.2-6.3l11.1-10V34.3
					h6.5v6.4l7.7,7.8l-6.8,6.1l10.1,9v8.9h5.1v10.7l-6.2,5.5h-15.4v4.1h15.9l9.1-8.1v-8h6.6l8.8,8.2h8.7l-6.7-6v-4.3l-10.1-9l-7,6.3
					v-11l-10.8-9.6l4.6-4.1v-6.8h3.8v7l8.5,7.6h5l-4.9-4.4l4.8-4.3h12.3l4.7,4.2v7.6l8.9,8V62l-6.8-6v-6.9l-4.8-4.2v-8.6L1154,20
					l1.3-4.3h42l8-10.8h27.6l19.6,13.9h8.4l-8.7,7.8h-4c-2,0-3.9,0.7-5.4,1.9l-18.5,16.6l4.3,2.9l12.7-11.3l24,4.8h35l17.2-15.4
					l23.4,30.8h8.2v-6.7l52.3-5.5v7.7c0-0.6,7.9-7,7.9-7h8.2c3.9-0.1,7.6,2,9.4,5.5c1.8,3.5,5.5,5.6,9.4,5.5h14.6
					c5.4,0,10.6,1.5,15.1,4.4c4.6,3.1,10,4.7,15.5,4.7h17.3l4.9-4.4h7.3l-3.6,3.2l7.2,6.4h7.2l3.8-3.4l20.8-0.1
					c4.1,0,8,1.6,10.8,4.6l17.9,18.7h5.1l4.5,4c1.4,1.3,3.3,1.9,5.2,1.9c0.5,0,1-0.1,1.5-0.2c0.2,0,0.5-0.1,0.7-0.1
					c3.2,0,5.8,2.3,5.8,5.2c0,1.4-0.7,2.8-1.7,3.7c-0.9,0.7-1.5,1.7-1.5,2.9c0,1.1,0.5,2.1,1.3,2.8l5.2,4.5h-2.7l-4.2-3.7h-4.6
					l-2.4-2.1c-0.8-0.7-1.9-1.1-3-1.1h-6.2c-2.5,0.1-4.6-1.8-4.7-4.2v-3.8h-3.1v7.9h-2.2c-1.2-0.1-2.3,0.7-2.5,2
					c-0.1,1.2,0.7,2.3,2,2.5c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.7-0.1c1.3,0,2.5,0.4,3.4,1.3l11.5,10.3h-5.5l-7.2-6.4v3.1
					c0,2.9-2.6,5.2-5.8,5.2c-0.5,0-1-0.1-1.5-0.2c-0.4-0.1-0.8-0.1-1.2-0.1c-1.5,0-3,0.5-4.1,1.5l-7.7,6.9
					c-3.9,3.4-9.7,3.4-13.6,0.1l-2.2-2l-6.3,5.7l-6.2-5.5v6.1h-6.4v7.7c0,1.7,0.8,3.4,2.1,4.5l2.2,1.9c1.9,1.6,3,4,3,6.5v12
					l-3.9,3.5v4.6h-4.8c-3.4,0-6.2,2.5-6.2,5.5v8.9h-4.4v-7l-9.4-16.2v-6.8c0-3-1.1-5.9-3.1-8.2c-0.4-0.5-0.7-1.2-0.7-1.9
					c0.1-2,1.8-3.5,3.8-3.4h5.5l7.8-6.9c1.3-1.1,2.1-2.8,2.1-4.5v-0.7c0-1.8,0.8-3.5,2.2-4.6l2.8-2.5v-14.4h-3.4v6.1l-9.9,8.9h-5.8
					v-6.4c-0.1-0.9-0.8-1.6-1.8-1.6c-0.5,0-0.9,0.2-1.3,0.5l-2.1,1.9h-3.4c-2.5,0-5,0.9-6.9,2.6l-7.3,6.6v5.4h-7.4l-3.9-3.5H1449
					c-2.2-0.1-4.3,1.1-5.4,3c-1.1,1.9-3.2,3-5.4,3c-1.6,0-3.1-0.5-4.3-1.6l-2.1-1.9c-2.5-2.2-6.3-2.2-8.8,0.1l-5.3,4.8v2
					c0,3.1-1.3,6-3.4,8.2l-13.5,13.1c-0.8,0.6-1.3,1.5-1.3,2.5c0.1,2,1.8,3.5,3.8,3.4l1.7-0.1c2.5,0,4.8,0.9,6.7,2.5l4.6,4.1h4.1
					V175h6.2l-0.1,4c0.1,1.6,1.6,2.8,3.2,2.7c2.2,0,4.1,1.6,4.1,3.5c0,0.9-0.4,1.8-1.1,2.4l-2.6,2.3v6.7l1.9,1.6
					c1,0.8,1.5,2,1.5,3.3v21.1h-4.8l-7.2,13.9c-1.8,3.2-5.2,5.1-8.8,5h-8.6v4.6h-3.5l-2.4-2.5l3.8-4.9l-3.8-4.7l-0.2-3.6h3.1
					l2.5,4.1l2.1-1.1l1-6.8l4-1.7l-2.5-7l3.6-8.3h-4l-3,4.9l-13.3-1.5l0.2-5.5l-2.7-0.9l-3.2,2.2l-3.4-2.2v-2.6h-8.3v-3.9l-2-1.8
					v-4.9l-7.6-6l-4.2-7.9l-7.8,3.2l-8.6-3.2l-9.1,4.1v2.4l3.7,0.2v4.2l-2.8,2.6l0.2,8.5l-6.3,2.6l-9.5-5.3l-2.3,2.1h-3.2v-3h-2.5
					l-4,3.6v3.3h-10l-2.4,2.2l-11.3-2l-4.3-3.9l-3.2,1.1l-6.3-4.1l-3.6,2.8l-12.7-2.3v-3.9l-4.4-3.9h-8.1l-4.7-4.2h-2.3v5.5h-2.5
					v2.6l3.8,3.2l-1.5,3.4l-6.5-1.7l-10.3,0.6l0.1-2.5c-0.1-1-0.9-1.8-1.9-1.7c0,0,0,0,0,0h-3.6l-2.1-1.9h-2.5l-1.5,5.1h-2.7l-1.9-3
					h-3.6v6.4c0,1-0.9,1.8-1.9,1.7c0,0,0,0,0,0h-4.8v4.5h-5.3c-1,0-1.9,0.7-1.9,1.7v1.7h-8.9v2.3l4.8,4.3l-3.6,3.2l-3.3-3h-2.7v7.7
					l-4,3.6h-4c-1-0.1-1.8,0.7-1.9,1.7c0,0,0,0,0,0v5l-2.6,2.4c-0.7,0.6-0.8,1.6-0.2,2.3c0.1,0.1,0.2,0.2,0.3,0.3l1.6,1.5v3.8
					c-0.1,1-0.9,1.8-1.9,1.7h-2.7l-5.7,5.1h-4.4c-1-0.1-1.9,0.7-1.9,1.7c0,0,0,0,0,0v2.2l-2.5,2.1l-4.4-4l-4.8,4.3l-0.4,4.8l4.6,0.1
					l2.7,2.3l-0.1,6.8l-3.8,3.4h-5.8l-3.3-2.9l-3.4,3.1V272h-4.7l2.8-2.5h-3.2l-5.8,5.3h-4.4l-2.6,2.4l-2.9-2.8h-7.2V271l-6,5.4v4.7
					h-2.9v3.4l-5,4.5l-2.3-2.3h-5.2v-9.2h-4.9l-3.1-2.7h-3.5l-3.1-2.9h-6.6l-3.5,3.1l-2.1-1.9h-4V269h-3.8l-6.9-8.3v-3.6h6.9
					l-6.6-5.9h-2.1c-1.2,0.1-2.2-0.8-2.3-2c0,0,0,0,0,0v-3.5h-2.9l-4.8-7.7h-3.2v-3.2h3.2c1.2,0.1,2.2-0.9,2.3-2.1l-0.1-2.8l8.6-4.3
					v-3.8l-10.7-2.8l-11.4,5.5l0.1,2.5c-0.1,1.2-1.1,2.1-2.3,2.1h-1.6c-1.2-0.1-2.2,0.9-2.3,2.1l-1,8.1l14.5,17.1l0.1,7.6l-3.2,5.5
					h-4.2l0.1-6.8h-5.4l-0.1,2.6h-4.4l-6.2-5.6l-5.2-0.1v-6.3h-8.3l-2.9-3.1v-3.7l-6-4.7h-4l-6.1-5.5h-5.2v-3.4l2.4-2.2v-3.6
					l4.7-4.1v-3.7h-5.9l-4.4,3.8h-7.4l-6.5,5.8l-3.8-3.5l-3,2.7h-2.7l3.3-2.9l-3.8-3.4h-4.6l-4.4,3.8v4.3l-3.1,4.2h-4.9v-4.4
					l-2.1-2.6v-8.6l2.3-2.1v-5.1h-8.4v-2.1h-2.5l-3.9,3.5h-7.8l-3.8-3.4h-3.1v-3.1l2.3-2.1l3.5-0.5v-4.8l3.7-3.5l-2.3-3.1l4.3-2.6
					l-2.4-2.4v-6.4h-6.4v-5.2l-4.4-3.9l-2.2,2h-3.6v-4.2l3.7-3.3l-2.8-2.5v-7.5l5-4.5h3v2.9l4.5,4h2.3v-8.1l-2.1-1.9v-6.9h4.3
					l2.3,2.1l4.8-4.3l3.5,3.1h3.4v-3.8h4.6l3.8-3.4l-3.8-3.4h-5.2v-3.2l3.9-3.4h3.3v-3.9l3.2-3.4c1.2-1.1,1.3-2.9,0.3-4.1
					c-0.1-0.1-0.2-0.2-0.3-0.3l-2.3-2.6v-5.8l-3-2.7V98l1.5-1.4v-4.5l-3.4-3c-0.7-0.6-0.8-1.7-0.2-2.4c0.1-0.1,0.1-0.1,0.2-0.2
					l1.3-1.1v-3.2l-4.7-4.2v-3.1L901.7,73z"
                ></path>
                <polygon
                  class="st0"
                  points="1018.6,55.1 1023.7,59.7 1023.7,62.4 1017.5,56.8 1013.1,60.7 997,50 1007.7,40.5 1007.7,34.9 
					1012.5,30.6 1012.5,22.9 1019.5,22.9 1027.8,15.5 1047.8,15.5 1057.2,7.1 1064.9,7.1 1064.9,12.2 1048.2,19.3 1039.6,19.3 
					1028.7,29.1 1023.9,29.1 1023.9,38.3 1016,38.3 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="984.9,69.5 984.9,75.6 988.3,72.5 994.8,72.5 994.8,69.5 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1352.1,20.4 1362.6,29.7 1367.7,29.7 1367.7,26 1388.6,26 1392.2,22.8 1387,18.2 1370.1,18.2 
					1365.3,18.2 1359.9,13.4 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1395.4,19.6 1407.4,30.3 1414.9,30.3 1414.9,25.4 1409.4,25.4 1402.2,19 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1376.6,36.7 1388.9,36.7 1388.9,34 1385.1,30.6 1379.3,30.6 1376.7,33 				"
                ></polygon>
              </g>
              <path
                id="Sud_Africa"
                class="st0"
                d="M857.2,615.3l4.9-4.4h2v3.8l2.5,2.3l3-2.6h5.9v-14.1l5.4,4.8h4.7l5.1-4.6V596l2.9,2.6h6.3
				l5.2-4.6c0.6-0.5,0.9-1.2,0.9-1.9v-1.8c0.1-1,0.9-1.8,2-1.7h4l4.8-4.3v-4h14.5v8.3l7.4,6.6l-4,3.6h-2.7l-3.7,3.3v5.2l2.7,2.4
				l4-3.4l4.1,3l-1.8,4.8h-3.8l-2.7,8.3l-18.1,19l-11.2,5.5l-8.6-2.6l-14.7,4l-2.2,1.9h-4.4v-3.6l-5.7-5.1v-6.2l-3.6-4.5v-7.7
				l-5-4.4L857.2,615.3z"
              ></path>
              <path
                id="Ruanda"
                class="st0"
                d="M935.3,474.5v6.2l-10.7,9.6l-2.3-2.7c-0.7-0.7-1.1-1.6-1.1-2.6c0-0.4,0.1-0.9,0.2-1.3l2.1-6.8
				h4.4l2.7-2.5L935.3,474.5z"
              ></path>
              <path
                id="Sudan"
                class="st0"
                d="M889.7,413.8l2.9,2.6v6.8l4.5,4h4.9l4.5,4v4.5c0.1,1,1,1.8,2.1,1.7c1-0.1,2,0.7,2.1,1.7l-0.1,4.9
				l4.5,4h7.8c2.4-0.1,4.6,1.2,5.7,3.4l3.5-3.1l3.6,3.2l1-1c0.4-0.3,0.9-0.5,1.4-0.5c0.5,0,1,0.2,1.4,0.6c0.4,0.6,1,0.9,1.7,0.9
				c0.5,0,1.1-0.2,1.5-0.5l4.2-3.9l5.8-0.4V442l-5.2-4.6v-4.1H943l-3.8-3.4l0.3,0.3c-0.5-0.4-0.9-1-0.9-1.6c0.1-1.2,1.1-2.2,2.4-2.1
				l2.8,0l3.4-3l-2.7-2.5v-4c0.1-1,1-1.7,2-1.7c1,0.1,1.9-0.7,2-1.7v-5.1l5.8-5.1v-9.9l2.8-2.5v-6.8l4.4-4h3.4V376l-3.9-3.5
				l-2.8-16.7l-6.3-5.6l-6.2,2.6v2.9l-3,2.7h-45.8l-0.1,2.1l2.5,2.2v6.2l-4.5,1.5v16.4l-4.3,3.9v7.8l-3.4,3
				c-0.7,0.3-1.2,1.1-1.2,1.8c0,0.7,0.3,1.3,0.9,1.7l2.8,2.4L889.7,413.8z"
              ></path>
              <polygon
                id="Senegal"
                class="st0"
                points="715.7,394 715.6,398.5 718.5,398.5 720.7,400.5 720.7,407 713.8,407 700.5,403.7 
				696.3,407.4 696.3,399.9 692.1,396.1 698,390.9 697.8,385.1 706.1,385.1 			"
              ></polygon>
              <path
                id="Somalia"
                class="st0"
                d="M991.9,408.6v4.3h5.7l4.8,4.3h7.1l3.9-3.5h10.7l2.7-2.5h1.4c2.1-0.1,4,1.5,4.1,3.7v2.4
				l-8.4,13.2v6.8l-9.3,9.8l-5.5,10.9l-6.7,1.1l-2.5,2.8c-0.9,1.1-2.2,1.7-3.7,1.7c-2.2,0-4.3,1.6-4.3,3.7l-1.3,5.4l-9.4,5.6v-23.9
				l8.1-6.5c0.5,0,1,0.2,1.4,0.5l1,0.9l4.2-3.8h4.7l12.8-11.5c0.7-0.3,1.2-1.1,1.3-1.9c0-0.9-0.6-1.7-1.4-2l-14.7-6h-4.2v-2.7
				l-6.3-6.8v-3L991.9,408.6z"
              ></path>
              <path
                id="Togo"
                class="st0"
                d="M783.1,412.5l2.5,2.2v7.6l0.6,0.5c0.5,0.4,0.9,1,0.9,1.7c0,0.5-0.2,0.9-0.5,1.3l-2.2,4.3l1.5,7.9
				l-2.4,2.4l-3.7-0.1v-6.7l-2.5-2.2v-3.8l2-1.8V422l-2.5-2.3l3.1-2.8l-2.5-2.2h3.2L783.1,412.5z"
              ></path>
              <path
                id="Costa_d_avoriio"
                class="st0"
                d="M742.9,449.1l7.3-6.5H761l2.7,2.3v-5.5l-2.5-2.3c-0.9-0.6-1.1-1.9-0.5-2.8
				c0.1-0.1,0.2-0.3,0.3-0.4l1.5-1.3v-6.4h3.4l-2.5-5.7h-8.3l-3.3-2.9h-3.4v-3.2h-2.4l-3.1,2.8h-4.3v4.8l2.8,2.5v5l-5.2,4.5l4.5,4.1
				v11L742.9,449.1z"
              ></path>
              <polygon
                id="Sierra_Leone"
                class="st0"
                points="713.5,421.9 716.7,421.9 719.3,419.6 722.6,419.6 725.3,427 725.3,430.4 
				719.2,434.7 			"
              ></polygon>
              <polygon
                id="Namibia"
                class="st0"
                points="857.2,615.3 847.5,597.5 847.5,585.4 837.5,565.8 837.5,557 841.2,553.7 845.3,553.7 
				849.2,557.1 854.4,557.1 857.3,554.5 869.4,554.5 873.5,558.2 882.8,558.2 887.1,559.5 879.7,565.4 879.7,577.9 875.5,581.6 
				875.5,614.4 869.6,614.4 866.6,617 864.1,614.8 864.1,611 862.2,611 			"
              ></polygon>
              <path
                id="Mali"
                class="st0"
                d="M754.8,341.5H750c-2-0.1-3.8,1.5-3.9,3.5c0,0,0,0,0,0v21.9l2.7,2.4v14.4l2.2,2l-3.3,6.9h-20.5
				l-2.4,2.2l-3.5-3.1h-2.5l-3.1,2.5v4.4h2.7l2.2,2v6.6l2.7,2.5l2-1.8l2.2,2l3.1-2.8l5.4,4.8v3.2l2.4,2.2h4.3l3.1-2.8h2.4v3.2h3.4
				v-6.4l3.5-3.1v-2.7l3.8-3.4h4.3l4.1-3.6h3.5l6.3-5.8h16.3l6.9-6.2v-9.6l2.1-1.9v-4.1h-3.5l-3,2.6h-4.1v-3.5l2.6-2.4l-3-2.6H786
				L754.8,341.5z"
              ></path>
              <polygon
                id="Liberia"
                class="st0"
                points="740.6,438 740.6,449 735,449.1 719.2,434.7 725.3,430.4 725.3,427 730.6,427 
				730.6,429.1 728.2,431.2 730.5,433.3 736,433.3 			"
              ></polygon>
              <path
                id="Zaire"
                class="st0"
                d="M867.8,456.4l-3,2.5v12.7l-4.1,3.7l-5.2,13.3l-6.7,6l-3.3-2.9h-3.2l-2.9,5.5l1.3,4l3-2.7h12.2
				c1.2-0.1,2.2,0.8,2.2,2v2.1l7.9,7.1l2.3-2.1h3.6c1,0.1,1.9-0.8,2-1.8l-0.1-1c0.1-1.1,1-1.9,2.1-1.8h2.4l4.2,3.8h3.6v5.3l-1.4,1.3
				c-0.4,0.3-0.6,0.8-0.6,1.3c0,0.6,0.3,1.1,0.8,1.5l2.8,2.5l-0.1,6c0.1,1.1,1,1.9,2.1,1.9l9.5-1l5.9,3.4l2.6-2.4l8.9,8.2l0,2.3h8.3
				l2.4-2.2v-2.9h-8.5l-1.2-1.1c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.4,0.2-0.7,0.6-0.9l2.1-1.9v-8.4c0-0.7-0.3-1.3-0.9-1.7l-0.7-0.5
				c-0.9-0.7-1-1.9-0.3-2.8c0.1-0.1,0.2-0.2,0.3-0.3l1.6-1.3h8.3l-3.7-3v-18.5l-2.3-2.7c-0.7-0.7-1.1-1.6-1.1-2.6
				c0-0.4,0.1-0.9,0.2-1.3l3.8-13.7l-2-1.8c-0.6-0.5-0.7-1.3-0.2-1.9c0-0.1,0.1-0.1,0.1-0.1l3-2.7v-2.5h6.4v-2.7l-3.5-3.1v-1.5
				c0-3-2.8-5.5-6.2-5.5h-7.8l-4.5-4H903l-0.7,0.8c-0.6,0.5-1.4,0.8-2.2,0.8c-0.5,0-1-0.1-1.5-0.3c-0.4-0.2-0.8-0.2-1.3-0.3
				c-0.8,0-1.6,0.3-2.2,0.8l-0.6,0.6H889l-3.5,3.1h-5.8V447l-3.6-3.2h-3.5l-4.8,4.1L867.8,456.4z"
              ></path>
              <path
                id="Zimbabwe"
                class="st0"
                d="M931.6,580l4.8-4l0.2-4l5.1-4.3c0.4-0.2,0.7-0.7,0.7-1.2c0-0.4-0.2-0.8-0.6-1.1l-2.1-1.8V555
				l-4.1-3.7h-6.6l-2.7-2.2l-5.7,4.8l-15.3,5.3v7.2c0,0.8,0.4,1.5,1,2l2,1.8h2.6l2.9,2.6v4.4l2.8,2.8L931.6,580z"
              ></path>
              <path
                id="Etiopia"
                class="st0"
                d="M988.3,411.8v3l6.3,6.8v2.7h4.2l14.7,6c0.8,0.3,1.4,1.1,1.4,2c-0.1,0.8-0.5,1.5-1.3,1.9
				l-12.8,11.5H996l-4.2,3.8l-1-0.9c-0.4-0.3-0.9-0.5-1.4-0.5c-0.6,0-1.1,0.2-1.5,0.6l-2.7,2.4l-4.5-4h-4.3l-4.6,4.1h-6.2l-3.2-2.9
				c-1.3-1.4-3.5-1.5-4.9-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c-0.4,0.4-0.9,0.6-1.5,0.6c-0.6,0-1.1-0.2-1.5-0.6l-1.5-1.3V442l-5.2-4.6
				v-4.1H943l-3.8-3.4l0.3,0.3c-0.5-0.4-0.9-1-0.9-1.6c0.1-1.2,1.1-2.2,2.4-2.1l2.8,0l3.4-3l-2.7-2.5v-4c0.1-1,1-1.7,2-1.7
				c1,0.1,1.9-0.7,2-1.7v-5.1l5.8-5.1v-9.9l2.8-2.5v-6.8l4.4-4h3.4V376l9.5,8.5v5.5l7,6.2v3l10.5,9.4L988.3,411.8z"
              ></path>
              <polygon
                id="Shara"
                class="st0"
                points="736.1,327.8 736.2,334.2 729.5,337 724.1,335.5 708.5,338.5 713.5,329.8 713.5,326.1 
				719,326.1 728.1,327.8 			"
              ></polygon>
              <path
                id="Mauritania"
                class="st0"
                d="M736.2,327.8v6.4l-6.6,2.8l-5.5-1.5l-15.6,3h-3.4V349l-8,7.1c-1.4,1.2-2.2,2.9-2.3,4.7
				c0,1,0.3,2,0.7,2.8l2.3,5.7l-0.2,15.7h8.3l10,9l2.8-2.5h2.5l3.5,3.1l2.4-2.2h20.4l3.3-6.9l-2.2-2v-14.3l-2.7-2.4V345
				c0.1-2,1.8-3.6,3.9-3.5h4.8L736.2,327.8z"
              ></path>
              <polygon
                id="Guinea"
                class="st0"
                points="736,433.3 730.5,433.3 728.2,431.2 730.6,429.1 730.6,427 725.3,427 722.6,419.6 
				719.3,419.6 716.7,421.9 713.5,421.9 712.3,419.1 705.5,416.5 703.4,411.2 696.3,407.4 700.5,403.7 713.8,407 720.7,407 
				723.4,409.5 725.4,407.7 727.7,409.7 730.7,407 736.1,411.8 736.1,415 738.5,417.1 738.5,421.9 741.3,424.4 741.3,429.5 			"
              ></polygon>
              <path
                id="Benin"
                class="st0"
                d="M786,437.9l-1.5-7.9l2.2-4.3c0.3-0.4,0.5-0.8,0.5-1.3c0-0.7-0.3-1.3-0.9-1.7l-0.6-0.5v-7.6
				l-2.5-2.2l3.1-2.7h6.9l3.1,2.8v3.7l-4.8,4.3v8.3l-1.4,1.3v4.6L786,437.9z"
              ></path>
              <polygon
                id="Gabon"
                class="st0"
                points="842.5,457.6 836.9,457.6 834.5,455.4 834.5,461.9 832.3,463.8 826.8,462.2 826.8,466.2 
				823.5,469.2 826.4,480.9 833.8,487.1 833.8,481.3 837.3,481.3 840.3,478.6 842.4,480.5 845.1,480.5 847.1,482.3 849.5,480.2 
				849.5,472.2 847,470 847,461.7 			"
              ></polygon>
              <path
                id="Repubblica_africana_centrale"
                class="st0"
                d="M854.2,429.9h11.4l4.3-3.9c0.9-0.7,2-1.2,3.1-1.1h1.8l2-1.8h1.4
				c1,0,1.9-0.8,1.9-1.8c0-1.2,0.5-2.4,1.5-3.2l4.7-4.2h3.5l2.9,2.6v6.8l4.5,4h4.9l4.5,4v4.5c0.1,1,1,1.8,2.1,1.7
				c1-0.1,2,0.7,2.1,1.7l-0.1,4.9H903l-0.7,0.8c-0.6,0.5-1.4,0.8-2.2,0.8c-0.5,0-1-0.1-1.5-0.3c-0.4-0.2-0.8-0.2-1.3-0.3
				c-0.8,0-1.6,0.3-2.2,0.8l-0.6,0.6H889l-3.5,3.1h-5.8v-2.7l-3.6-3.2h-3.5l-4.8,4.1v4.7h-7.1l-4.2,3.8l-8-10.4v-4.1L854.2,429.9z"
              ></path>
              <polyline
                id="Upper_volta"
                class="st0"
                points="785.4,392.5 777.1,392.5 770.8,398.3 767.3,398.3 763.2,401.9 759,401.9 
				755.1,405.4 755.1,408.1 751.7,411.2 751.7,417.6 754.9,420.5 763.2,420.5 763.2,416.9 765.5,414.8 780.7,414.8 786.2,409.8 
				789.5,409.7 789.5,405.7 783.2,405.7 783.2,400.1 780.1,397.3 785.4,392.5 			"
              ></polyline>
              <path
                class="st6"
                d="M945.6,542.5v8l-5.7-0.3l-4.6,1.2h-6.2l-3.4-3.1v-2.5l2.6-2.3v-3.8l-3.4-3l2.4-2.2v-2.9h-8.5l-1.2-1.1
				c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.1,0-0.2,0.1-0.3c0.1-0.2,0.3-0.5,0.5-0.6l2.1-1.9v-8.4c0-0.7-0.3-1.3-0.9-1.7l-0.7-0.5
				c-0.9-0.7-1-1.9-0.3-2.8c0.1-0.1,0.2-0.2,0.3-0.3l1.6-1.3h8.3l3,3h5.3l6,5.4l-0.2,0.1l-2.5,2.2v14.9L945.6,542.5z"
              ></path>
              <polygon
                id="Niger"
                class="st0"
                points="835.9,347.9 830.8,354.8 826.7,354.8 820.5,360.2 815.6,360.2 804.5,370.7 802.4,370.7 
				802.4,374.8 800.2,376.7 800.2,386.3 793.3,392.5 785.4,392.5 780.1,397.3 783.2,400.1 783.2,405.7 789.5,405.7 789.5,409.7 
				793,409.8 798,405.4 798,402.8 802.8,398.5 805.9,398.5 809.1,401.4 814.6,401.4 818,404.4 821.1,404.4 825.1,400.8 835.5,400.8 
				837.8,398.8 841.8,398.8 855.7,386.3 855.7,372.4 850.5,367.8 856.4,362.5 850.4,357.1 850.4,349.8 847.9,352.1 844.5,352.1 
				839.9,347.9 			"
              ></polygon>
              <path
                id="Uganda"
                class="st0"
                d="M947,447.2l-4.2,3.8c-0.4,0.4-0.9,0.6-1.5,0.5c-0.7,0-1.3-0.3-1.7-0.9c-0.4-0.4-0.9-0.6-1.4-0.6
				c-0.5,0-1,0.2-1.4,0.5l-1,1l-3.6-3.2l-3.6,3.2c0.3,0.7,0.5,1.4,0.5,2.2v1.5l3.5,3.1v2.7h-6.4v2.5l-3,2.7
				c-0.6,0.5-0.6,1.4-0.1,1.9c0,0,0.1,0.1,0.1,0.1l2,1.8l-1.8,6.9h4.4l2.7-2.5h4.6l4.2-3.8h5.9v-3.9c0-1.7,0.9-3.2,2.3-4.1
				c1.2-0.9,2-2.3,2-3.8v-5.1l-2.2-2v-4.8L947,447.2z"
              ></path>
              <path
                id="Chad"
                class="st0"
                d="M852,348.4h4.1l38.7,22.1v16.4l-4.3,3.9v7.8l-3.4,3c-0.7,0.3-1.2,1.1-1.2,1.8
				c0,0.7,0.3,1.3,0.9,1.7l2.8,2.4v6.3h-3.5l-4.7,4.2c-0.9,0.8-1.4,2-1.5,3.2c0,1-0.9,1.8-1.9,1.8h-1.4l-2,1.8H873
				c-1.1,0-2.2,0.4-3.1,1.1l-4.3,3.9h-11.4l0.5-1.2l-4.4-3.9v-3.3l3-2.6c0.4-0.3,0.6-0.8,0.6-1.2c0-0.5-0.2-0.9-0.6-1.2l-3.3-2.9
				v-2.1h-3.2v-4.7l-5-4.5v-3.4l13.9-12.4v-13.9l-5.2-4.6l5.9-5.3l-6-5.4v-7.3L852,348.4z"
              ></path>
              <polygon
                id="Malawy"
                class="st0"
                points="942.5,520.4 947.2,520.4 947.2,525 949.7,527.2 949.7,537.8 953.6,541.3 953.6,548.5 
				948.2,553.3 945.6,550.9 945.6,542.5 939.9,537.4 939.9,522.5 			"
              ></polygon>
              <path
                id="Bozwana"
                class="st0"
                d="M875.5,600.3l5.4,4.8h4.7l5.1-4.6V596l2.9,2.6h6.3l5.2-4.6c0.6-0.5,0.9-1.2,0.9-1.9v-1.8
				c0.1-1,0.9-1.8,2-1.7h4l4.8-4.3v-4.5l-2.8-2.5v-4.4l-2.9-2.6h-2.5l-2-1.8c-0.6-0.5-1-1.2-1-2v-7.2l-10.3,3.3l-8-3l-7.4,5.9V578
				l-4.2,3.8L875.5,600.3z"
              ></path>
              <g id="Papua_nuova_Guinea">
                <polygon
                  class="st0"
                  points="1515.8,539.5 1515.8,542.7 1527.6,545.5 1533.7,539.9 1533.7,537.4 1530.5,534.6 1530.5,537.4 
					1525.2,537.4 1522.8,535.3 1518.4,539.4 				"
                ></polygon>
                <path
                  class="st0"
                  d="M1481.7,530.5h11.9c3.6,0,6.6,2.6,6.6,5.9l-0.1,3.4h5.2l8,7.2h-5l4.8,4.3v4.7h3.4l5.7,5.1h4v3.6h-13
					l-5.7-5.1v-3.2l-5-4.5h-6.5v1.9h-4.4v4.4l-13.1-0.1L1481.7,530.5z"
                ></path>
              </g>
              <polygon
                id="Timor_est"
                class="st0"
                points="1403.4,518.8 1410.7,518.8 1410.7,512.9 1408,512.9 1405,515.5 			"
              ></polygon>
              <g id="Indonesia">
                <polygon
                  class="st0"
                  points="1359.4,516.1 1362.1,518.5 1364.9,515.9 1371.2,515.9 1371.2,513.1 1362.5,513.1 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1374.2,515.7 1374.2,513.1 1386,513.1 1382.9,515.8 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="1397.2,515.5 1392.1,520.1 1393,524.4 1397.2,524.4 1403.4,518.8 1405,515.5 				"
                ></polygon>
                <path
                  class="st0"
                  d="M1271.7,470.9c0.1,1.2,1.1,2.2,2.4,2.1c0,0,0,0,0,0h3.7v4l2.8,2.5v5.2h3.9l9.6,15h8.9V495h3.4v-10.2
					l-8.8-7.9h-3.4v-4l-9.1-8.2v-1.5c-0.1-1.2-1.1-2.2-2.3-2.1c0,0,0,0,0,0h-5.9l-7.6-6.8v-5.9h-2.2l-5-4.4h-8.2v-2.6h-2.9l0.1,2.7
					l4.5,4v2.3l5.7,5.1h4v4.7l6.5,5.8L1271.7,470.9z"
                ></path>
                <path
                  class="st0"
                  d="M1344.6,508.5c1.2-0.1,2.3,0.9,2.4,2.1c0,0.6-0.2,1.1-0.6,1.5l-2.6,2.3h-9l-3.3-2.9h-12.9l-1.6,1.5l-2.3-2
					h-7v-3.1h-3.8c-1.2,0.1-2.3-0.9-2.4-2.1c0-0.6,0.2-1.1,0.7-1.5l3.9-3.5h6.4l6.9,6.2h5.1l2.8-2.5h5l4.6,4.1L1344.6,508.5z"
                ></path>
                <path
                  class="st0"
                  d="M1478.5,517.3c-1.3,0.1-2.4-0.6-3-1.7c-0.1-1.6-1.5-2.8-3.1-2.7c0,0,0,0,0,0h-9.6c-0.9,0.1-1.6-0.6-1.7-1.5
					c0,0,0,0,0,0c0-0.4,0.2-0.8,0.5-1.1l4-3.5v-2.7l-2.7-2.4l-0.1-1.3c-0.1-1.6-1.5-2.9-3.1-2.8l-6.9-0.3l-7.6-6.8h-5.5l-2.5-2.1
					c-0.5-0.3-0.8-0.8-0.8-1.3c0-0.4,0.2-0.8,0.5-1.1l1.9-1.7l-6.2-5.6l5.4-6.7h4.4v2.6l4.4-0.1c0.9-0.1,1.7,0.6,1.7,1.5
					c0,0,0,0,0,0c0,0.4-0.2,0.8-0.5,1.1l-3.2,2.8l6.6,5.9h5.4v-1.2c0.1-0.8,0.8-1.4,1.6-1.4h1.2v-2.1h6.7l15.2,8.7L1478.5,517.3z"
                ></path>
                <path
                  class="st0"
                  d="M1373.7,469.4l5.6-5.1c0.6-0.9,1.6-1.4,2.6-1.3c0.9,0,1.7,0.4,2.3,1l2.9,2.7h7.6l3.5-3.1h5.6l-6.6,5.9h-15
					l-3.6,3.2v4.9h2.9l2.8-2.4h4.9c0.8,0,1.5,0.6,1.6,1.4c0,0,0,0,0,0c0,0.4-0.2,0.8-0.4,1l-3.3,3.1h-5.6v2.3l5.4,4.8v5.1l-3.1,2.8
					v-2.5l-2.3-2v-4.8l-2.2-2l-3,2.7l2.5,2.2v2.9l-2,1.8v8.3l-3.8,0.1c-1.6,0.1-3-1.2-3.1-2.8v-4.1c0-0.8-0.3-1.5-0.9-2l-1.8-1.5
					v-2.5l2.8-2.7l-0.1-4.4c0-0.9,0.5-1.8,1.3-2.3l1.6-1.3c0.5-0.4,0.8-1.1,0.8-1.7L1373.7,469.4z"
                ></path>
                <path
                  class="st0"
                  d="M1327.8,463.6l-1.9-1.7h-3.6l-3.2,7.4h2.9v7.8l3.9,3.5v6l3,2.7l1.6-1.5h2.9l3.4,3.2c1.6,1.3,4,1.3,5.5-0.2
					l1.9-1.6h4.5l3.5,3c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,2.1-0.5,2.7-1.3l4.2-8.4l-2.5-2.3l2.1-5.6h4.1l2.7-7.2h1.8
					c0.9,0,1.7-0.6,1.7-1.5c0-0.5-0.2-0.9-0.6-1.2l-5.1-4.7v-8.7l-5.9-5.4l-4.6,4.5v4.2l-11.8,9.3l-2.3-2.1l-5.8,5.1l-2.2-2h-2.8
					L1327.8,463.6z"
                ></path>
              </g>
              <path
                id="Bangladesh"
                class="st0"
                d="M1231.9,358.6l-2.7,2.5h-4.6v-3.8l-3.6-3.2v4.6h-5.1v-4l-5.1-4.5v-9.9l-5.2-4.6h6.4l6.2,5.5
				c1,0.8,2.3,1.2,3.6,1.2c1.2,0,2.4-0.4,3.4-1.1c0.5-0.4,1.1-0.6,1.8-0.6c1.5-0.1,2.7,1,2.8,2.5v4.6l2.1,1.9L1231.9,358.6z"
              ></path>
              <path
                id="Thailandia"
                class="st0"
                d="M1270.5,370.3l3.2,2.8v2.2c0.1,1.4,1.3,2.4,2.6,2.3h4.4l3,2.6l2.4-2.2
				c0.5-0.6,1.2-0.9,2-0.9c0.7,0,1.3,0.2,1.8,0.7l5.2,4.7v3.9l5.1,4.6l-1.7,5.6l-3.9,3.5l-4.2-3.8h-2.3c-1.4-0.1-2.5,1-2.6,2.3
				c0,0,0,0,0,0v5.8l1.9,1.7v3h-7.5c-1.4,0.1-2.5-1-2.6-2.3l0.1-7.1l-2.1,1.8v8.4l-1.4,1.2v4.9l-3.2,2.8v4.5
				c0.1,1.4,1.2,2.4,2.6,2.3c0,0,0,0,0,0h1.7l2.9,2.6v5.9c0,0.9,0.8,1.5,1.6,1.5h3.8c1.8-0.1,3.3,1.3,3.4,3.1v3.7l5.6,5
				c1.4,1.2,2.2,3,2.2,4.9l-0.1,7.9l2.2,2l-2.4,2.2l-7.7-6.9l-1.6,1.4h-3.4V454l-3.2-2.8V444l-9.7-10.4v-2.4h-2.1
				c-0.9,0.1-1.6-0.6-1.7-1.5c0,0,0,0,0,0V424l2.1-1.9V413l1.8-1.6v-12.1l-3.3-2.9v-13.2l-6.7-6v-5.8c0.1-1.4,1.2-2.4,2.6-2.3
				l0.7-0.1l4.1-3.7h4.2L1270.5,370.3z"
              ></path>
              <g id="Malesia">
                <path
                  class="st0"
                  d="M1327.8,463.6h3.2l6.5-5.8h3.8l4.6-9.2l8-4.1c0.9-0.3,1.6-1.2,1.6-2.1l-0.1-2.6l4.7-4.2l2.5,2.3l-0.1,3.3
					c0.1,1.5,1.3,2.6,2.8,2.5l7.3-0.1v3h-3c-0.8,0-1.4,0.6-1.5,1.3v2.1l-2.6,2.2l-5.9-5.4l-4.7,4.3v4.2l-11.8,9.3l-2.3-2.1l-5.8,5.1
					l-2.2-2h-2.8L1327.8,463.6z"
                ></path>
                <path
                  class="st0"
                  d="M1273,426.1h1.7l2.9,2.6v5.9c0,0.9,0.8,1.5,1.6,1.5h3.9c1.8-0.1,3.3,1.3,3.4,3.1v3.7l5.6,5
					c1.4,1.2,2.2,3,2.3,4.9l-0.1,8l2.2,2l-2.4,2.2l-7.7-6.9l-1.6,1.4h-3.4v-5.3l-3.2-2.8v-7.2l-9.7-10.4v-2.4
					C1268.6,431.4,1271.6,426.1,1273,426.1z"
                ></path>
              </g>
              <path
                id="Nepal"
                class="st0"
                d="M1241.1,313l3.4,3.1v4.5c0.1,1.4,1.2,2.4,2.6,2.3h4.6v5.7h-3.9c-1.4-0.1-2.5,1-2.6,2.3v2.2
				l-4.8,4.3v8l-3.1,2.8v10.4h-5.5v-8.9l-2.1-1.9v-4.6c-0.1-1.5-1.3-2.6-2.8-2.5c-0.6,0-1.3,0.2-1.8,0.6c-1,0.7-2.2,1.1-3.4,1.1
				c-1.3,0-2.6-0.4-3.6-1.2l-6.2-5.5h-14.6v-3h-2.5c-1.5,0-2.9-0.9-3.6-2.2c-0.7-1.4-2.1-2.2-3.6-2.2h-6.4c-2.1,0-4.1-0.7-5.6-2.1
				l-3.6-3.2h-1.4c-1.6,0.1-2.9-1.1-3-2.7v-8.7h9.5l6.5,5.9c0.4,0.3,0.9,0.5,1.4,0.5c0.6,0,1.2-0.2,1.6-0.6l1.9-1.8v3.9h3.6l6.8,6.1
				h12.9v3.4l3.9,3.5h11.1v-7.1h4.5c1.4,0.1,2.5-1,2.6-2.3v-3.5L1241.1,313l3.4,3.1"
              ></path>
              <g id="India">
                <path
                  class="st1"
                  d="M1247.2,322.9c-1.4,0.1-2.5-1-2.6-2.3v-4.5l-3.4-3.1l-7.2,6.4v3.5c-0.1,1.4-1.2,2.4-2.6,2.3h-4.5v7.1h-11.1
					l-3.9-3.5v-3.4h-12.9l13.1,10.1l0.1,0.1l-14.7-0.1v-3h-2.5c-1.5,0-2.9-0.9-3.6-2.2c-0.7-1.4-2.1-2.2-3.6-2.2h-6.4
					c-2.1,0-4.1-0.7-5.6-2.1l-3.6-3.2h-1.4c-1.6,0.1-2.9-1.1-3-2.7v-8.7l-3.6-3.2h-3.2c-1.6,0.2-3-1-3.2-2.6c-0.2-1.6,1-3,2.6-3.2
					c0.2,0,0.4,0,0.6,0h0.8c1.3,0.1,2.4-0.9,2.5-2.2c0-0.6-0.3-1.2-0.7-1.6l-2.5-2.2v-5.3l3-2.7v-4.4l-9.4-1.7v2.8h-2.7l-8.1,6.5
					l-2-1.8h-2.9v6.8h3.2c-0.1,1.5-1.4,2.7-3,2.7c0,0,0,0,0,0h-2.1v3.1l1.7,1.5v4.8l-9.2,13.8v2.4c-0.1,1.4-1.3,2.5-2.7,2.4
					c-0.6,0-1.2-0.2-1.7-0.5c-0.8-0.7-1.9-1.1-3-1.1c-2.3-0.1-4.2,1.6-4.3,3.9c0,1.2,0.6,2.2,1.5,2.9l3.1,2.8
					c0.8,0.7,1.3,1.8,1.3,2.9c-0.1,2.4-2.2,4.2-4.6,4.1l-1.6,0c-1.9,0-3.7,0.7-5.2,1.9l-4.5,4l6.8,6.1h6.7v2.9l-2.6,2.3l5.8,5.2h5.6
					v-6.6l5.8,5.2V377l3.9,3.5v13.3l6.1,5.4l4.4,16l6.3,5.7v8.4l3.5,3.1l3.2-2.8h3.1v-6.7l2.6-2.3c1.9-1.7,3-4.1,3.1-6.7v-8.5
					l5.9-5.3l-4.2-3.8v-3.5h6.3l6.9-6.1c1.9-1.8,3-4.4,3-7c0.1-1.8,1.3-3.3,3-3.7c1.6-0.3,3-1.1,4.2-2.2l5.8-5.2h4.4v-6.3
					c0.1-1.3,1.2-2.3,2.5-2.3c0.7,0,1.3,0.2,1.8,0.7l1.5,1.5h2.7v-7.7l-5.1-4.5v-9.9l4.1-2l3.3,2.9c1,0.8,2.3,1.2,3.6,1.2
					c1.2,0,2.4-0.4,3.4-1.1c0.5-0.4,1.1-0.6,1.8-0.6c1.5-0.1,2.7,1,2.8,2.5v4.6l2.1,1.9v8.9h5.5v-10.4l3.1-2.8v-8l4.8-4.3v-2.2
					c0.1-1.4,1.2-2.4,2.6-2.3h3.9v-5.7L1247.2,322.9z"
                ></path>
                <path
                  class="st4"
                  d="M1247.2,322.9c-1.4,0.1-2.5-1-2.6-2.3v-4.5l-3.4-3.1l-7.2,6.4v3.5c-0.1,1.4-1.2,2.4-2.6,2.3h-4.5v7.1h-11.1
					l-3.9-3.5v-3.4h-12.9l13.1,10.1l0.1,0.1l-14.7-0.1v-3h-2.5c-1.5,0-2.9-0.9-3.6-2.2c-0.7-1.4-2.1-2.2-3.6-2.2h-6.4
					c-2.1,0-4.1-0.7-5.6-2.1l-3.6-3.2h-1.4c-1.6,0.1-2.9-1.1-3-2.7v-8.7l-3.6-3.2h-3.2c-1.6,0.2-3-1-3.2-2.6c-0.2-1.6,1-3,2.6-3.2
					c0.2,0,0.4,0,0.6,0h0.8c1.3,0.1,2.4-0.9,2.5-2.2c0-0.6-0.3-1.2-0.7-1.6l-2.5-2.2v-5.3l3-2.7v-4.4l-9.4-1.7v2.8h-2.7l-8.1,6.5
					l-2-1.8h-2.9v6.8h3.2c-0.1,1.5-1.4,2.7-3,2.7c0,0,0,0,0,0h-2.1v3.1l1.7,1.5v4.8l-9.2,13.8v2.4c-0.1,1.4-1.3,2.5-2.7,2.4
					c-0.6,0-1.2-0.2-1.7-0.5c-0.8-0.7-1.9-1.1-3-1.1c-2.3-0.1-4.2,1.6-4.3,3.9c0,1.2,0.6,2.2,1.5,2.9l3.1,2.8
					c0.8,0.7,1.3,1.8,1.3,2.9c-0.1,2.4-2.2,4.2-4.6,4.1l-1.6,0c-1.9,0-3.7,0.7-5.2,1.9l-4.5,4l6.8,6.1h6.7v2.9l-2.6,2.3l5.8,5.2h5.6
					v-6.6l5.8,5.2V377l3.9,3.5v13.3l6.1,5.4l4.4,16l6.3,5.7v8.4l3.5,3.1l3.2-2.8h3.1v-6.7l2.6-2.3c1.9-1.7,3-4.1,3.1-6.7v-8.5
					l5.9-5.3l-4.2-3.8v-3.5h6.3l6.9-6.1c1.9-1.8,3-4.4,3-7c0.1-1.8,1.3-3.3,3-3.7c1.6-0.3,3-1.1,4.2-2.2l5.8-5.2h4.4v-6.3
					c0.1-1.3,1.2-2.3,2.5-2.3c0.7,0,1.3,0.2,1.8,0.7l1.5,1.5h2.7v-7.7l-5.1-4.5v-9.9l4.1-2l3.3,2.9c1,0.8,2.3,1.2,3.6,1.2
					c1.2,0,2.4-0.4,3.4-1.1c0.5-0.4,1.1-0.6,1.8-0.6c1.5-0.1,2.7,1,2.8,2.5v4.6l2.1,1.9v8.9h5.5v-10.4l3.1-2.8v-8l4.8-4.3v-2.2
					c0.1-1.4,1.2-2.4,2.6-2.3h3.9v-5.7L1247.2,322.9z"
                ></path>
              </g>
              <path
                id="Pakistan"
                class="st0"
                d="M1093.1,318.6l8.3-8.6h0.6c1.3,0.1,2.6-0.7,3-2c0.5-1.1,1.6-1.8,2.8-1.8h6v-3.8l3.8-3.4
				l0.1-2.1c0-1.3,0.9-2.3,2.2-2.6l5-1.5V287l-2-1.8v-2.1l5.5-5.3h5.8l3.8-3.4h4l3.2,2.8v1.3c0.1,1,0.9,1.8,1.9,1.7h1.9l2.8,5.1
				l-8.1,6.5l-2-1.8h-2.9v6.8h3.2c-0.1,1.5-1.4,2.7-3,2.7c0,0,0,0,0,0h-2.1v3.1l1.7,1.5v4.8l-9.2,13.8v2.4c-0.1,1.4-1.3,2.5-2.7,2.4
				c-0.6,0-1.2-0.2-1.7-0.5c-0.8-0.7-1.9-1.1-3-1.1c-2.3-0.1-4.2,1.6-4.3,3.9c0,1.2,0.6,2.2,1.5,2.9l3.1,2.8
				c0.8,0.7,1.3,1.8,1.3,2.9c-0.1,2.4-2.2,4.2-4.6,4.1l-1.6,0c-1.9,0-3.7,0.7-5.2,1.9l-4.5,3.9l-8-7.3l-10-0.2l-3.9,3.4h-7.8v-4.2
				h2.7v-2l6.6-5.9v-3.4h-1.3c-1.2,0.1-2.2-0.9-2.3-2.1v-2c-0.1-1.4-1.3-2.5-2.7-2.4c0,0,0,0,0,0h-2.4v-3.9L1093.1,318.6z"
              ></path>
              <path
                id="Oman"
                class="st0"
                d="M1033.6,377.5l9.4-8.4h4.3v-6.3l3.9-3.5v-2.2l-2.9-2.6l7.4-11.6l12.6,11c2.2,1.8,2.6,5,0.8,7.3
				c-0.2,0.3-0.4,0.5-0.7,0.7l-7.5,7.7v5.1l-5.5,2.5v3.2h-6.1v3.4h-6.1l-4.4,3L1033.6,377.5z"
              ></path>
              <polygon
                class="st0"
                points="1008.8,390.4 1005.5,390.4 1001.9,393.6 1004.3,395.8 1004.3,399 999.4,399 993,404.8 988.8,401.2 
				988.8,396.2 986.3,394 988.5,392 988.5,386.7 991,384.5 991,381.8 1001.6,381.8 1011.3,388 			"
              ></polygon>
              <polygon
                id="Siria"
                class="st0"
                points="950.7,283.1 954.5,279.7 966.6,279.7 969.6,277 980.7,277 980.7,280.1 977.9,282.7 
				977.9,289.2 968.2,298 966.3,296.4 960.4,296.4 953,303.1 949.7,300.2 949.7,297.3 953.8,295.2 953.8,292.2 950.7,292.2 			"
              ></polygon>
              <path
                id="Iran"
                class="st0"
                d="M986.4,259.5l5.2,0.1l6.2,5.6h4.3l0.1-2.6h5.4l-0.1,6.8h4.2l2.9,6.2h5.9l3.4,3h14.3l3-5.5h4
				l2.1,1.9l3.5-3.1h6.6l3.1,2.9h3.5l3.1,2.7h4.9v9.2l-3.6,3.3c-0.8,0.7-1.3,1.8-1.3,2.9c0,0.9,0.4,1.8,1,2.5l3.4,3l-2,1.8v4.3
				l6.8,6.1l-3.3,2.9l5.5,4.9v3.9h2.4c1.4-0.1,2.6,1,2.7,2.4c0,0,0,0,0,0v2c0.1,1.2,1.1,2.1,2.3,2.1h1.3v3.4l-6.6,5.9v2h-2.8
				l0.3,4.1l-19.7-6.6l-3.8-6.6h-5.7v3l-21.9-8.5v-4.5l-6-5.3l-6.8-0.1l-5.2-4.8v-7.3c-0.1-1.5-1.4-2.7-2.9-2.6l-2.1,0l-8.3-7.4
				v-7.9l2.7-2.5l-7.4-6.6v-7.9l-4.6-4.1L986.4,259.5z"
              ></path>
              <path
                id="Algeria"
                class="st0"
                d="M835.9,347.9l-5.3-4.7h-4v-6l-1.1-1c-1-0.5-1.3-1.7-0.8-2.7c0.2-0.3,0.4-0.5,0.6-0.7l1.9-1.6
				l-2.4-9v-14.5l-1.6-1.6l-9.6-10.2v-3.1l5.3-4.8v-2.3l-2.3-2.1v-5.1l-7.6-2.6h-8.6c-1.7,0-3.3,0.6-4.6,1.7l-2.3,2.1h-10.4
				l-3.9,3.5h-6.1l-4.4,4v9.8l3.8,3.4v3.2h-5.3l-3.5,3.1v2.7l2.7,2.4l-30.3,15.9l49.9,37.1h5.5l3,2.6l-2.6,2.4v3.5h4.1l3-2.6h5.7
				l11.1-10.5h5l6.2-5.5h4.2L835.9,347.9z"
              ></path>
              <polygon
                id="Marocco"
                class="st0"
                points="719,326.1 726.2,319.7 731.2,319.7 731.2,308.4 738.4,296.3 743.9,296.3 747.7,288.4 
				752.3,283.9 756.5,287.3 768.7,287.3 768.7,297.1 772.5,300.5 772.5,303.7 767.2,303.7 763.8,306.8 763.8,309.5 766.4,311.9 
				736.1,327.8 728.1,327.8 			"
              ></polygon>
              <path
                id="Libia"
                class="st0"
                d="M823.2,306.1l6.4-5.8v-3.1l22.8,6.2v3.6l11.4,2.1l7.8,5.3l4-2.8l-1.9-4.5l4.4-6h8.8l7,6.2
				l6.3,0.2v4.9l-3.5,3.1v45.1l2.5,2.2v6.2l-4.5,1.5l-38.7-22.1H852l-4.1,3.7h-3.4l-4.6-4.1h-4l-5.3-4.7h-4v-6l-1.1-1
				c-1-0.5-1.3-1.7-0.8-2.7c0.2-0.3,0.4-0.5,0.6-0.7l1.9-1.6l-2.4-9v-14.5L823.2,306.1z"
              ></path>
              <polygon
                id="Tunisia"
                class="st0"
                points="816.7,278.6 816.7,283.7 819,285.8 819,288 813.7,292.8 813.7,295.9 823.2,306.1 
				829.7,300.4 829.7,297.3 827.9,296.5 827.9,294 832.8,285.7 830.7,283.9 830.7,282.3 832.7,280.5 832.7,278.5 825.9,278.5 
				823.9,276.7 			"
              ></polygon>
              <polygon
                id="Ukraina"
                class="st0"
                points="929.5,233.4 929.5,231.2 934.1,231.2 937.3,228.2 941.5,228.2 944.4,230.8 
				941.6,233.3 938.8,233.3 935.3,236.4 932.8,236.4 932.8,233.4 			"
              ></polygon>
              <path
                id="Kazakhstan"
                class="st0"
                d="M1178.5,212.3v-3.9l-1.9-1.6V203l-3.8-3.3l-1.7,1.4h-3.1l-3.6-3.1h-5l-4.1-3.5l-3.1,2.7
				h-3.8l-1.8-2.2l-2.1,1.2l0.7,1.7l-1.2,0.9l-4.5-5.5l-1.8-4.3l-11.9-7.6l2-1.7l-2.3-2l-5.5,4.7v3.6l-2.6-2.2l-3.4,2.9V184l2.4-2.1
				l-1.2-1l-4.6,4v-2.7h-4.8v-3.2l-3.4-2.9h-3.6l-3.9,3.3h-11.5l-6.7,5.7l-2.8-2.4v2.2h-5.5l2.5,2.1h1.8v3h-4.8v1.8l-1.9,1.6v3.5
				h3.4l1.7,1.5l4.1,3.5h-5.1l-1.9,1.6l-3.6-3.1l-3.2,2.7v-1.4l-4.4-3.8l-3,2.6l-3.8-3.2l-3,2.6h-2.5v-1.6l-4.7-4l-1.2,1l-3.6-3.1
				h-2.7l-2.7-2.3l-3.4,2.9l-1.9-1.6l-0.9,0.8v2.3h-3.3v2.7l-1.5,1.2l-3.9-3.3l-3.8,3.2v3.5l-3.2,2.7l1.5,1.3v2.4l1.7,1.4v-1.1
				l1.8,1.5l5.2,4.4v1.7h-4l1.5,3.3l3.1-1.8v1.6l0.2-0.1l10.7,2.8v3.8l-8.6,4.3v2.8c-0.1,1.2-1.1,2.1-2.3,2.1h-3.2v3.2h3.1l4.8,7.7
				h2.9v3.5c0,1.2,1,2.1,2.2,2.1c0,0,0,0,0,0h2.1l6.6,5.9h-6.9v3.6l6.9,8.3h3.8v4.1h4l2.1,1.9l3.4-3.1h6.6l3.3,2.8h3.5l2.8,2.7h5.2
				v9.3h4.8l2.7,2.2l5-4.5v-3.4h2.9v-4.7l6-5.4v3.3h7.2l2.9,2.8l2.6-2.4h4.4l5.8-5.3h3.2l-2.8,2.5h4.7v6.1l3.5-3.1l3.4,2.9h5.8
				l3.8-3.4l0.1-6.8l-2.7-2.3l-4.6-0.1l0.4-4.8l4.8-4.3l4.4,4l2.6-2.1v-2.3c0-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0l4.3,0.1l5.7-5.1
				l1.7,0.1c1.1,0,3.1-0.8,3.1-1.7v-3.8l-1.6-1.5c-0.4-0.3-0.7-0.8-0.7-1.4c0-0.5,0.2-0.9,0.6-1.2l2.6-2.4v-5c0-1,0.9-1.8,1.9-1.7
				c0,0,0,0,0,0h3.8l4-3.6v-7.7h2.7l3.4,3l3.5-3.2l-4.8-4.3v-2.3L1178.5,212.3z"
              ></path>
              <polygon
                id="Turkmenistan"
                class="st0"
                points="1089.7,274 1072.4,266.5 1072.4,262.5 1072.4,260.6 1069.4,258 1064.9,258 
				1064.9,260 1061.6,257.2 1061.6,253.6 1059.3,251.6 1060.6,250.5 1057.7,250.5 1056,251.9 1052.8,249.2 1052.5,251.5 
				1049.6,250.4 1047.8,251.5 1049.4,256.2 1039.1,254.6 1036.5,248.1 1029.1,248.1 1026.8,250 1028.6,251.2 1030.7,251.2 
				1037.3,257.1 1030.4,257.1 1030.4,260.7 1037.3,269 1041.1,269 1041.1,273.1 1045,273.1 1047.1,275 1050.6,271.9 1057.2,271.9 
				1060.5,274.8 1064,274.8 1066.8,277.5 1072,277.5 1072,286.7 1076.8,286.7 1079.5,289 1084.6,284.5 1084.6,281.1 1087.5,281 
				1087.5,276.3 			"
              ></polygon>
              <path
                id="Kyrgizstan"
                class="st0"
                d="M1124.4,264.7l0.3-2.7l2.1-1.8h-2.1v-1.7h-4.1l-2-1.8l-2.5,2.6V258h-1.2l-1.3-1.1l2.9-2.5
				l1.6-1.3l-2.4-1.4l3.5-2.7l2.6,2.2l2.6-2.2l3.6,3.1l1.6-1.4l-1.9-1.6v-2h2.7l2.6-2.2l2.3,2h4l3-2.6h10.9l1.3,1.1h2.6l2.6,2.1l0,0
				c-0.1,1-0.9,1.7-1.9,1.6c0,0,0,0,0,0h-2.7l-5.7,5.1l-4.3-0.1c-1-0.1-1.9,0.7-1.9,1.7c0,0,0,0,0,0v2.3l-2.6,2.1l-4.4-4l-4.8,4.3
				l-0.4,4.8L1124.4,264.7z"
              ></path>
              <polygon
                id="Tagikistan"
                class="st0"
                points="1102,275.8 1103.2,273.6 1102.8,272.6 1100.7,273.3 1098.2,271.2 1099.9,268.8 
				1104.2,270 1105.9,267.4 1105.2,265.7 1107.6,265 1106.7,264.2 1108.5,262 1110.2,262.1 1113.7,261.2 1115.5,262.7 1114.1,263.8 
				1116.8,264.8 1115.9,266.6 1117.9,266.6 1119,265.1 1121.3,265 1121.4,262.5 1124.4,264.7 1130.8,265.3 1130.8,265.3 
				1135.4,265.4 1138.1,267.7 1138,274.5 1134.2,277.9 1128.4,277.9 1125,275 1121.6,278 1121.6,271.9 1116.8,271.9 1119.7,269.4 
				1116.5,269.4 1110.7,274.7 1106.2,274.7 1103.6,277 			"
              ></polygon>
              <polygon
                id="Uzbekistan"
                class="st0"
                points="1124.4,264.7 1121.4,262.5 1121.3,265 1119,265.1 1117.9,266.6 1115.9,266.6 
				1116.8,264.8 1114.1,263.8 1115.5,262.7 1113.7,261.2 1110.2,262.1 1108.5,262 1106.7,264.2 1107.6,265 1105.2,265.7 
				1105.9,267.4 1104.2,270 1099.9,268.8 1098.2,271.2 1100.7,273.3 1102.8,272.6 1103.2,273.6 1102,275.8 1100.7,274.3 
				1093.5,274.3 1093.5,271 1089.7,274 1072.4,266.5 1072.4,262.5 1072.4,260.6 1069.4,258 1064.9,258 1064.9,260 1061.6,257.2 
				1061.6,253.6 1059.3,251.6 1060.6,250.5 1057.7,250.5 1056,251.9 1052.8,249.2 1052.5,251.5 1049.6,250.4 1047.8,251.5 
				1049.4,256.2 1041.6,255.1 1043.9,252.1 1041.6,238.8 1044.9,233.4 1057.9,231.6 1057.9,229.4 1059.9,229.4 1060.6,230.4 
				1060.3,232.6 1063,231.3 1061.9,230.4 1061.9,228.9 1063.5,228.9 1064.7,230.5 1067,229.3 1065.1,227.7 1065.1,225.1 
				1067.6,225.1 1068.9,226.2 1072.3,226.2 1072.3,228.9 1069.7,228.9 1067.7,230.5 1070.6,236.9 1068.3,239.1 1072.6,245 
				1073.8,244 1084,245.3 1086.7,243.6 1087.7,245.9 1090.7,250 1092.1,249.5 1093.3,252.2 1090.6,253.9 1090.6,256.1 1094.7,256.1 
				1094.7,259.5 1105.1,259.5 1115.4,251.7 1117.8,253 1113.4,256.8 1114.7,258 1116,258 1116,259.5 1118.5,256.9 1120.6,258.6 
				1124.6,258.6 1124.6,260.3 1126.8,260.3 1124.7,262 			"
              ></polygon>
              <polygon
                id="Ukraina-2"
                class="st0"
                points="952.8,221 949.7,219 949.7,217.7 945.7,214.7 945.7,211.7 948.5,209.8 948.5,206.7 
				951.2,206.7 955.4,203.1 955.4,201.8 958.3,199.3 962,199.3 962,196.4 959.8,196.4 961.3,195.1 961.3,192.3 958.1,192.3 
				959.8,190.8 959.8,188.9 952.7,188.9 950.4,190.9 947.1,188.1 944.4,190.4 944.4,188.2 939.9,188.2 937.3,190.4 937.3,187.7 
				934.4,185.2 931.3,185.2 931.3,183.5 927.9,180.6 925.7,182.6 923.5,182.6 923.5,184.2 921,184.2 917.6,187.1 917.6,191.1 
				913.9,191.1 911.4,189 909.1,190.9 906.6,188.8 904.6,190.6 900,190.6 897.5,188.4 896.1,189.6 891.8,189.6 887.5,192.2 
				889.8,195.3 886.2,198.8 886.2,203.5 882.6,204.1 880.3,206.2 880.3,209.2 883.4,209.2 887.2,212.5 895,212.5 899,209.1 
				901.5,209.1 901.5,211.2 909.9,211.2 909.9,216.3 907.6,218.4 907.5,227.1 909.6,229.7 909.7,234.1 914.5,234.1 917.7,229.9 
				917.7,225.6 921.8,221.8 926.8,221.8 930.5,225.1 927.2,228.1 929.9,228.1 932.9,225.4 936.7,228.9 934.2,231.2 929.6,231.2 
				929.6,233.4 932.9,233.4 932.9,236.4 935.4,236.4 938.8,233.3 941.6,233.3 944.4,230.8 941.5,228.2 937.3,228.2 943.2,223 
				950.7,223 			"
              ></polygon>
              <polygon
                id="Latvia"
                class="st0"
                points="888.7,154.5 890.4,154.5 893.2,156.9 895.7,154.8 898.9,157.5 898.9,160.3 901.1,160.3 
				901.1,163.1 896,167.9 891.5,164.6 889.9,163.2 887.4,163.2 887.4,164.7 880.4,164.7 880.4,163.1 876.4,166.4 873.6,163.9 
				873.6,156.3 878.6,151.8 881.6,151.8 881.6,154.7 886.1,158.8 888.4,158.8 			"
              ></polygon>
              <polygon
                id="Estonia"
                class="st0"
                points="888.7,154.5 890.4,154.5 893.2,156.9 897.5,153.4 895.3,152.1 895.3,149.2 893,147.8 
				897.9,147.8 897.9,145.9 896.7,144.9 894,144.9 892.9,144 890.6,141.9 885.5,141.9 885.5,148.8 888.4,150.6 			"
              ></polygon>
              <polygon
                id="Moldavia"
                class="st0"
                points="918,222.8 915,217.9 912.9,217.9 912.9,214.8 909.8,214.8 909.9,216.3 907.6,218.4 
				907.5,227.1 909.6,229.7 909.6,232.6 913.2,232.6 914.8,230.6 914.8,224.1 917.1,224.1 917.5,222.8 			"
              ></polygon>
              <polygon
                id="Georgia"
                class="st0"
                points="998.2,255.4 993.3,255.3 990.2,253.2 986.4,253.2 978.4,253.2 975.2,250.3 
				975.2,246.6 969.2,241.8 965.5,241.8 963.9,240.5 963.9,236.6 977.7,241.7 977.7,244.1 986.1,244.1 			"
              ></polygon>
              <polygon
                id="Belarus"
                class="st0"
                points="923.5,184.2 921,184.2 917.6,187.1 917.6,191.1 913.9,191.1 911.4,189 909.1,190.9 
				906.6,188.8 904.6,190.6 900,190.6 897.5,188.4 896.1,189.6 891.8,189.6 889.3,187.4 889.3,180.9 882.9,180.9 882.9,179.9 
				885.2,178.2 889.4,178.2 891.1,176.8 892.8,178.3 894.8,176.6 893,175.2 895.2,173.3 894.1,173.3 894.1,171.3 897,171.3 
				898.5,170.1 896,170.1 896,167.9 901.1,163.1 902.3,164.1 903.4,163.2 906.3,163.2 906.3,165.3 908.9,163.1 913,163.1 913,165.9 
				914.3,167 911.6,169.3 915.7,172.7 918.5,172.7 918.5,175.7 920.3,174.1 922.1,175.6 922.1,177.8 918.5,177.8 918.5,179.2 
				923.5,182.6 			"
              ></polygon>
              <polygon
                id="Armenia"
                class="st0"
                points="986.4,259.5 986.4,253.2 990.5,253.2 993.3,255.3 998.2,255.4 997.9,257.8 
				1000.3,257.8 1000.3,262.6 1002.3,262.6 1002.2,265.2 998.3,265.2 991.6,259.5 			"
              ></polygon>
              <polygon
                id="Azerbayijan"
                class="st0"
                points="1000.3,262.6 1002.3,262.6 1007.6,262.6 1007.5,269.4 1011.7,269.4 1014.9,263.8 
				1015,256.8 1004.9,244.9 1004.9,249 1000.4,249 1000.4,251.3 994.1,251.3 998.2,255.4 997.9,257.8 1000.3,257.8 			"
              ></polygon>
              <polygon
                id="Lesotho"
                class="st0"
                points="905.4,622.9 904.9,625.2 902.6,628 903.4,632.4 905.6,636 906.8,636.2 909.5,630.9 
				909,629 909.2,627.8 910.4,627 911,624.6 909.5,621 907.7,620.7 			"
              ></polygon>
              <polygon
                id="Yemen"
                class="st0"
                points="996.3,407.9 1003.1,401.8 1029.4,397.1 1035.3,393.3 1035.3,389.5 1038.8,386.9 
				1033.6,377.5 1016.9,377.5 1016.9,383.1 1011.3,388 1001.6,381.8 991,381.8 991,384.5 988.5,386.7 988.5,392 986.3,394 
				988.8,396.2 988.8,401.2 			"
              ></polygon>
              <path
                class="st0"
                d="M946.1,542.9l-0.5,7.6l0,0l-5.7-0.3l-4.6,1.2h-6.2l-2.7-2.2l-5.7,4.8l-25.6,8.6l-8.1-3l4.4-3.5l-4-3.6v-15.3
				l-2.2-2l2.9-2.6l4.9,0.1c1.9,0.1,3.5-1.3,3.6-3.2v-4.1l2.6-0.2l5.9,3.4l2.6-2.4l8.9,8.2l0,2.3h8.2l2.1-2l0.4-2.5l0.1-1l-8.7,0.4
				l-1.5-2.2l-0.1-0.1l2.7-2.3v-8.4l-1.6-2.2l-0.4-2.5l2-2h8.3l3,3h5.3l5.9,5.5l0.2,0.2l-2.6,2.1v14.9L946.1,542.9z"
              ></path>
              <path
                id="Uruguay"
                class="st0"
                d="M467.1,637.1l4.1-3.6l7,5.9c2,1.6,4.9,1.6,6.9,0l3.9-3.4v-5.5l4.4-3.8l-8.7-7.4
				c-2.1-1.7-4.7-2.7-7.4-2.8c-2.5,0-4.5-1.7-4.5-3.9c0,0-6,5.7-5.9,24.2"
              ></path>
              <g id="Regno_Unito">
                <polygon
                  class="st0"
                  points="455.6,730.5 455.6,727.8 457.1,726.5 457.1,724.4 460.1,724.4 463.5,727.3 467.2,727.3 
					463.8,730.3 463.8,733.1 458,733.1 458,730.5 				"
                ></polygon>
                <polygon
                  class="st0"
                  points="764,196.4 761.3,199.1 756.9,197.5 754,199.8 752.4,198.9 757.8,193.4 765.6,193.4 767.5,190.4 
					763.7,191 760.5,188.2 756.5,188.9 762.6,183.8 759.4,182.1 766.3,179.6 768.7,174.7 766.5,171.4 768.2,168.5 760.8,168.5 
					762,162.4 759,164.4 762.9,155.9 760,157 765,144.4 772.5,145.6 766.3,152.4 776.4,152.4 772.5,159 768.8,159.7 769.6,163.3 
					771.8,163 774.9,165.3 775,172.7 782.5,184 787.3,184 787.3,187.7 780.4,192.5 785.1,193.1 783,196.7 778.1,195.8 776.5,197.3 
					772.8,196.4 				"
                ></polygon>
                <polygon class="st0" points="750.8,165.5 755.2,169.2 753.3,174.6 745.8,167.3 				"></polygon>
              </g>
              <polyline
                id="Macedonia"
                class="st0"
                points="878.6,251 877.7,253.1 878.8,256 881.1,256.9 885.5,256.6 885.5,254.9 888.4,255.2 
				891,253.6 890.6,250.6 887.6,248.2 878.6,250.6 			"
              ></polyline>
              <polyline
                id="Bosnia_herzeg"
                class="st0"
                points="865.6,232.7 865.8,233.4 866,234.6 866.8,237.8 866.2,241.6 864.7,245.3 
				860.1,241.7 860.1,240.5 858.6,240.5 854.1,236.8 853.2,235 851.5,232 851.6,231.1 852.7,230.2 854.1,231.7 855.4,230.7 
				857.7,230.8 860.5,231.9 865.8,232.3 			"
              ></polyline>
              <polygon
                id="Repubblica_domenicana"
                class="st0"
                points="397.4,351.4 400.8,349 407.9,349 409.6,350.2 412.8,350.2 416.3,352.2 
				414.9,354.6 408.7,354.6 407,357.6 404.5,356.5 402.4,358.4 			"
              ></polygon>
              <polygon
                id="Cipro"
                class="st0"
                points="945.8,286.8 939.1,289.5 935.8,287.8 935,286 			"
              ></polygon>
              <polyline
                id="mirati_arabi"
                class="st0"
                points="1048.6,353.7 1055.7,343 1051.1,343 1047.4,343.4 1043,349.2 1041.8,351 
				1037.1,351.3 1034.4,353.1 1041.8,358.1 1047.4,362.2 1051.2,359.3 1051.2,357.1 1048.6,353.7 			"
              ></polyline>
              <path
                id="arabia_saudita"
                class="st0"
                d="M1041.8,358.1l-7.4-5l2.7-1.8l4.7-0.3l1.2-1.8l3.8-5l-7.3,2l-14.1-6.3l-4.8-10.4
				l-4.4-1.6c-1.2-0.4-2-1.5-2-2.7l0.1-2l-3.6-2.3v-0.6h-5.2l-3.5-3.1h-6.1l-4,3.6l-4.2-3.8l2.1-1.9c0.4-0.4,0.6-0.9,0.6-1.5
				c0-0.6-0.3-1.2-0.8-1.6l-4.1-3.6h-5.7l-5.9-5.2h-5.8l-9.7,3.7v3.8l-6.3,5.6l-1.5-1.5l-0.9,2.7l-0.6,5.1l10.9,17.1v5.5h3.6
				l7.2,6.4v9.4l6.3,6.8l11.4,18.8l2.4-2.2v-2.7h10.6l9.7,6.2l5.6-4.9v-5.6h16.7l9.4-8.4h4.3v-6.3l3.9-3.5l-3.8,2.9L1041.8,358.1z"
              ></path>
              <polygon class="st0" points="1043.6,339.8 1050.7,338.2 1045.7,345.4 1039.8,346 			"></polygon>
              <polyline class="st0" points="496.5,463.4 503.5,463.4 512,463.4 			"></polyline>
              <polyline
                id="Israele"
                class="st0"
                points="949.9,300.5 952.7,302.7 947,316.2 943.9,309.2 947,305.6 949.9,300.3 			"
              ></polyline>
              <g id="Giordania">
                <polygon
                  class="st0"
                  points="966.3,296.4 960.4,296.4 953,303.1 952.7,302.9 947,316.1 949.1,320.8 958.5,310.8 958.5,307 
					968.2,303.3 968.2,298.1 				"
                ></polygon>
              </g>
              <polyline
                id="Kuwait"
                class="st0"
                points="1010.3,320 1005.4,320 1003.2,317.8 1005.8,314.4 1008.8,313.3 1010.3,317.7 
				1010.4,319.4 			"
              ></polyline>
              <polygon
                class="st0"
                points="965.2,376.5 974.7,384.9 974.7,390 981.5,396.4 981.5,399.2 967.2,398.8 954.7,394.1 957.6,391 
				957.4,384.3 962.4,380.3 965.1,380.3 			"
              ></polygon>
              <polygon
                id="Quatar"
                class="st0"
                points="1036.8,340.4 1038.5,337.1 1039.6,341.4 1038.2,343.3 			"
              ></polygon>
              <path
                id="Brunei"
                class="st0"
                d="M1352.8,444.9c0,1.2,0.1,2.4,0.2,3.5l1.8-0.9l0.2-2.2l1.1-0.7l1.3,0.4l-2-2.9l-0.6,1.5
				L1352.8,444.9z"
              ></path>
              <polygon
                id="Guinea_equatoriale"
                class="st0"
                points="826.9,452.3 826.9,462.2 832.4,463.8 834.5,461.9 834.5,455.4 			"
              ></polygon>
              <path
                id="Cameroon"
                class="st0"
                d="M848.5,445.9v-4.1l6.2-13l-4.4-3.9v-3.3l3-2.6c0.3-0.3,0.6-0.8,0.6-1.2c0-0.5-0.2-0.9-0.6-1.2
				l-3.3-3v-2.1h-3.2l-8,8.3v3.4l0.7,0.6c0.9,0.6,1.2,1.8,0.6,2.8c-0.2,0.3-0.4,0.5-0.7,0.6l-4.3,3.8v3.7c0,1-0.9,1.8-1.9,1.7
				c0,0,0,0,0,0h-2.6l-3.4-3l-5.2,4.7v3.6l-2,1.8v2.7l6.9,6.2l7.6,3.1l2.5,2.2h5.6l2.6,2.4l3-2.6l4.2,2.8h1.8
				c1.2,0.1,2.3-0.9,2.4-2.1v-1.8L848.5,445.9z"
              ></path>
              <polygon
                id="Lituania"
                class="st0"
                points="897,171.3 898.5,170.1 896,170.1 896,167.9 891.5,164.6 889.9,163.2 887.4,163.2 
				887.4,164.7 880.4,164.7 880.4,163.1 876.4,166.4 876.3,173.8 878.5,171.9 882.9,175.8 882.9,179.9 885.2,178.2 889.4,178.2 
				891.1,176.8 892.8,178.3 894.8,176.6 893,175.2 895.2,173.3 894.1,173.3 894.1,171.3 			"
              ></polygon>
              <g id="Barbados">
                <polygon
                  class="st0"
                  points="435.7,400.7 438,399.6 439.8,399.9 441.2,402.5 439.2,403.6 436.3,403.6 				"
                ></polygon>
                <path class="st0" d="M438.8,396c0.9-0.7,1.9-1.4,2.9-2v2l-1.8,1.1L438.8,396z"></path>
              </g>
              <polygon
                id="Burundi"
                class="st0"
                points="929.3,485.8 924.5,490.3 924.5,496.6 929.7,493.7 			"
              ></polygon>
              <polygon
                id="belize"
                class="st0"
                points="306.4,368.9 311.1,368.6 308.7,370.7 308.7,374.4 305.1,374.4 			"
              ></polygon>
              <polygon id="Malta" class="st0" points="849.9,286.4 851.5,286.4 850.8,287.1 			"></polygon>
              <g id="Antille">
                <polygon class="st0" points="394.4,389.6 396,389.6 395.7,391 				"></polygon>
                <polygon class="st0" points="402.8,392.7 404.1,392.1 404.6,393.4 403.5,394 				"></polygon>
                <polygon class="st0" points="411.9,395.6 413.6,395.4 412.8,396.7 				"></polygon>
              </g>
              <polygon
                id="Hong_Kong"
                class="st0"
                points="1358.8,339.5 1361.9,340.9 1359.6,341.9 			"
              ></polygon>
              <polygon
                id="Singapore"
                class="st0"
                points="1296.5,462.7 1298.2,464.1 1295.3,466.1 1294,464.9 			"
              ></polygon>
              <g id="_egitto_" class="country_group">
                <polygon
                  id="Egitto"
                  class="st6"
                  points="951.9,350.2 951.9,344.9 936.7,327.2 936.7,319.3 942.6,324.6 947.4,324.6 
					947.4,321.8 945.6,320.2 947.6,316.5 944.2,309.2 935,310.3 932.5,308 927.7,308 926,309.6 920.4,309.6 918.4,311.4 
					911.9,307.5 900.3,307.5 900.3,312.3 896.9,315.4 896.9,358.5 942.6,358.5 945.7,355.7 945.7,352.8 				"
                ></polygon>
                <path
                  class="st7"
                  d="M919.2,322.5L919.2,322.5c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C906.8,328.1,912.3,322.5,919.2,322.5z"
                ></path>
                <line class="st8" x1="919.3" y1="330.2" x2="919.2" y2="339.9"></line>
                <line class="st8" x1="914.5" y1="335.1" x2="924" y2="335.1"></line>
                <text
                  transform="matrix(1 0 0 1 938.18 339.86)"
                  class="st7 st9 st10"
                >{{$ml.current === 'IT' ? 'Egitto' : 'Egypt'}}</text>
              </g>
              <g id="_iraq_" class="country_group">
                <path
                  id="Iraq"
                  class="st6"
                  d="M1010.6,318.5h3.4v-2.7l-5.1-4.8v-7.3c-0.1-1.5-1.4-2.7-2.9-2.6l-2.1,0l-8.3-7.4v-7.9l2.7-2.5
					l-7.4-6.4h-10.3v3.2l-2.8,2.5v6.5l-9.7,8.7v5.4h5.8l5.9,5.3h5.7l4.1,3.6c0.5,0.4,0.8,1,0.8,1.6c0,0.5-0.2,1.1-0.6,1.5l-2.1,1.8
					l4.2,3.8l4-3.6h6.1l3.5,3.1c1.7,0.1,3.4,0.1,5.2,0L1010.6,318.5z"
                ></path>
                <path
                  class="st7"
                  d="M989.8,286.5L989.8,286.5c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C977.3,292.1,982.9,286.5,989.8,286.5z"
                ></path>
                <line class="st8" x1="989.9" y1="294.2" x2="989.8" y2="303.8"></line>
                <line class="st8" x1="985.1" y1="299" x2="994.6" y2="299"></line>
                <text transform="matrix(1 0 0 1 1006.8401 303.09)" class="st7 st9 st10">Iraq</text>
              </g>
              <g id="_italia_" class="country_group">
                <g id="italia">
                  <polygon
                    class="st6"
                    points="817.6,255.8 820,254.2 823.2,254.4 824,258.2 822.8,259.2 823.3,260.1 822,266 821.2,265.9 
						820.1,264.7 819.1,264.7 819.3,266 818.5,266.7 816.5,266.6 816.5,265.6 815.2,264.7 815.5,257.1 814.6,256.5 815.8,253.7 
						816.8,253.7 816.1,254.3 816.1,255.3 					"
                  ></polygon>
                  <polygon
                    class="st6"
                    points="837.8,272 836,273.5 836,275.7 837.4,276.3 838.9,276 845.8,279.5 846.6,280.9 850.1,282 
						850.4,280.6 851.7,280 850.8,277.3 853,272.8 843,273.6 841.7,272.6 839.6,272.6 					"
                  ></polygon>
                  <polygon
                    class="st6"
                    points="839.6,221.7 837.9,222.1 836.3,221.3 836.8,219.7 835.9,218.9 834.2,219 834.2,220 832,220.4 
						831.1,221.6 829,222 827.5,221.9 825.9,223.9 826.5,224.7 823.3,225.4 822.2,224.5 820.8,228 820.5,226.5 819.5,226.6 
						818.3,224.9 816.7,227.2 812.4,228 811.1,228.6 811.3,229.8 812.6,230.6 812.4,231.9 810.5,232.6 812,234.8 811.2,235.3 
						813.2,237.4 816.6,237.4 815.8,239.2 816.9,239.9 819.1,237.3 822.1,236.5 828,238.5 828,242.2 832.2,248.3 833.5,248.3 
						839.2,254.3 842,255.3 844.1,255.3 850.2,261.4 854.2,262.8 856.6,268.1 853.8,274.8 856.7,274.7 858.5,272.4 858.5,269.9 
						861.6,269.2 861.5,266.2 858.9,265 858.8,263.1 860.8,260.4 866.7,262.4 866.7,263.4 868.4,264.1 868.3,261 855.6,254.1 
						857.2,253.1 857.2,252.1 852,251.6 847.1,248 845.2,242.6 842.2,240.7 837.8,236.5 837.8,234.4 839,234 839,232.6 837.8,231.4 
						837.8,230.4 841.5,228.6 843.1,228.6 843.1,225.3 842.2,224.8 843.3,222.7 					"
                  ></polygon>
                </g>
                <path
                  class="st7"
                  d="M843.2,237.1L843.2,237.1c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C830.7,242.7,836.3,237.1,843.2,237.1z"
                ></path>
                <line class="st8" x1="843.2" y1="244.8" x2="843.2" y2="254.4"></line>
                <line class="st8" x1="838.4" y1="249.6" x2="848" y2="249.6"></line>
                <text
                  transform="matrix(1 0 0 1 859.12 252.88)"
                  class="st7 st9 st10"
                >{{$ml.current === 'IT' ? 'Italia' : 'Italy'}}</text>
              </g>
              <g id="_messico_" class="country_group">
                <path
                  id="messico"
                  class="st6"
                  d="M285.4,378l-4.8-1.4l-6.6,3.3h-3.1l-2.6-1.9H264l-16.8-6.5l-1.3-3l-12.8-7.8
					c-2.5-1.4-4-4-4.1-6.9v-4.6c0-2.8-1.4-5.4-3.6-7.1L211,329.8v-6.4l-12.7-10.9v-10.4h-6.9v8.6l12.4,10.7v8l9.3,8v4.5h-4.9l-3.5-3
					c-0.6-0.5-1.4-0.9-2.2-1c-3.2-0.4-5.6-2.7-5.6-5.6v-7.7h-3.5l-8.1-6.9c-0.6-0.4-1-1.1-1-1.9c0.1-0.7,0.4-1.4,1-1.8
					c0.6-0.5,1-1.2,1.1-1.9c0-0.7-0.3-1.3-0.8-1.7l-0.6-0.5c-0.9-0.7-1.5-1.8-1.5-3v-15l-5.7-4.8h9.5l9.6,8.3
					c3.2,2.6,7.2,4,11.2,3.9h15l0.6-0.6c1.8-1.3,4-2,6.2-2c2.5,0,4.8,0.8,6.7,2.4l6.6,5.6v6l3.3,2.8v-2.4c0.1-1.8,1.8-3.2,3.6-3.1
					h3.1l4,3.4v4.4c0,2.2,1.1,4.2,2.8,5.5l8.4,7.3h3.3v5.7c-0.1,1.7-1.1,3.2-2.5,4.1l0,0c-1.5,0.7-2.6,2.2-2.7,3.8v5.1l-2.3,1.7v2.8
					l3.8,2.2v1.8l1.7,1.4l2.8,4.7c1.3,2.1,3.3,3.7,5.6,4.6l5.9,2.5l12.7-1.4v-2l2-0.7c1.4-0.3,2.4-1.4,2.4-2.8v-2.6
					c0.1-1.5,1.1-2.9,2.6-3.3l6.5-2.1h6.1c1.4-0.1,2.6,0.9,2.7,2.3c0,0.5-0.1,0.9-0.4,1.3l-5.8,9.2l-4.1,3.7H301v1.6
					c-1-0.1-1.9,0.7-1.9,1.6c0,0,0,0,0,0c0,0.4,0.2,0.7,0.4,1l1.9,2.2h-1.9c-1.3,0-2.5,0.6-3.1,1.8l-1,2v4.4L285.4,378z"
                ></path>
                <path
                  class="st7"
                  d="M251.2,342.6L251.2,342.6c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5h0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C238.7,348.2,244.3,342.6,251.2,342.6z"
                ></path>
                <line class="st8" x1="251.3" y1="350.3" x2="251.2" y2="359.9"></line>
                <line class="st8" x1="246.4" y1="355.1" x2="256" y2="355.1"></line>
                <text
                  transform="matrix(1 0 0 1 270.42 359.88)"
                  class="st7 st9 st10"
                >{{$ml.current === 'IT' ? 'Messico' : 'Mexico'}}</text>
              </g>
              <g id="_nigeria_" class="country_group">
                <path
                  id="Nigeria"
                  class="st6"
                  d="M793,409.8l3.1,2.8v3.7l-4.8,4.3v8.3l-1.4,1.3l-0.1,4.6h7.7l4,3.6v5.3l6,5.3
					c0,0,4.7,0.4,4.7,0s3.3-2.9,3.3-2.9h4.5l0.1-2.7l2-1.8v-3.6l5.3-4.7l3.4,3h2.6c1,0.1,1.9-0.7,1.9-1.7v-3.7l4.3-3.8
					c1-0.6,1.3-1.8,0.7-2.7c-0.2-0.3-0.4-0.5-0.6-0.7L839,423v-3.4l8-8.3v-4.7l-5-4.5v-3.4h-4l-2.2,2h-10.6l-4.1,3.6H818l-3.3-3
					h-5.5l-3.2-2.9h-3.1l-4.8,4.3v2.6L793,409.8z"
                ></path>
                <path
                  class="st7"
                  d="M814.7,410.8L814.7,410.8c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C802.2,416.3,807.8,410.8,814.7,410.8z"
                ></path>
                <line class="st8" x1="814.7" y1="418.4" x2="814.7" y2="428.1"></line>
                <line class="st8" x1="809.9" y1="423.3" x2="819.5" y2="423.3"></line>
                <text transform="matrix(1 0 0 1 832.77 428.94)" class="st7 st9 st10">Nigeria</text>
              </g>
              <g id="_ghana_" class="country_group">
                <path
                  id="Ghana"
                  class="st6"
                  d="M777.1,440.3l-6.9,6.2h-4.9l-1.7-1.6v-5.5l-2.5-2.3c-0.9-0.6-1.1-1.9-0.5-2.8
					c0.1-0.1,0.2-0.3,0.3-0.4l1.5-1.3v-6.4h3.4l-2.5-5.7v-3.7l2.3-2.1h12l2.5,2.2l-3.2,2.8l2.5,2.3v3.6l-2,1.8v3.8l2.5,2.2v6.7
					L777.1,440.3z"
                ></path>
                <path
                  class="st7"
                  d="M770.1,418.1L770.1,418.1c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C757.6,423.7,763.2,418.1,770.1,418.1z"
                ></path>
                <line class="st8" x1="770.2" y1="425.8" x2="770.1" y2="435.4"></line>
                <line class="st8" x1="765.3" y1="430.6" x2="774.9" y2="430.6"></line>
                <text transform="matrix(1 0 0 1 704.26 435.02)" class="st7 st9 st10">Ghana</text>
              </g>
              <g id="_congo_" class="country_group">
                <path
                  id="Congo"
                  class="st6"
                  d="M856.5,456.2l4.2-3.8h7.1v3.9l-3,2.5v12.7l-4.1,3.7l-5.2,13.3l-6.7,6l-3.3-2.9h-3.2l-2.9,5.5
					l-3.2-2.8v-4.7l-2.5-2.5v-5.8h3.6l3-2.6l2.1,1.9h2.7l2,1.8l2.3-2.1v-8L847,470v-8.3l-1.9-1.7l3-2.6l4.2,2.8h1.8
					c1.2,0,2.3-0.9,2.3-2.2V456.2z"
                ></path>
                <path
                  class="st7"
                  d="M853,464.7L853,464.7c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C840.5,470.3,846.1,464.7,853,464.7z"
                ></path>
                <line class="st8" x1="853.1" y1="472.4" x2="853" y2="482"></line>
                <line class="st8" x1="848.2" y1="477.3" x2="857.8" y2="477.3"></line>
                <text transform="matrix(1 0 0 1 786 482.39)" class="st7 st9 st10">Congo</text>
              </g>
              <g id="_angola_" class="country_group">
                <path
                  id="Angola"
                  class="st6"
                  d="M837.5,557l3.7-3.3h4.1l3.8,3.4h5.2l2.9-2.6h12l4.1,3.7h9.4l4.2,1.4l4.4-3.5l-4-3.6v-15.3
					l-2.2-2l2.9-2.6l4.9,0.1c1.9,0.1,3.5-1.3,3.6-3.2v-4.1l-6.8,0.8c-1.1,0-2-0.8-2.1-1.9l0.1-6l-2.8-2.4c-0.5-0.3-0.8-0.9-0.8-1.5
					c0-0.5,0.2-1,0.6-1.3l1.4-1.2v-5.3h-3.6l-4.2-3.8H876c-1.1,0-2,0.8-2.1,1.9l0.1,1c-0.1,1-1,1.9-2,1.8h-3.6l-2.3,2.1l-7.9-7.1
					v-2.1c-0.1-1.2-1.1-2.1-2.2-2h-12.2l-3,2.7l3,9.2l-2.7,2.3c-0.4,0.4-0.7,0.9-0.7,1.5c0,0.4,0.1,0.8,0.4,1.2l2.9,5.2v11l-4.1,3.6
					v9.9l-6.3,5.6v2.5L837.5,557z"
                ></path>
                <path
                  class="st7"
                  d="M863.6,521.2L863.6,521.2c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C851.1,526.8,856.7,521.2,863.6,521.2z"
                ></path>
                <line class="st8" x1="863.6" y1="528.9" x2="863.6" y2="538.6"></line>
                <line class="st8" x1="858.8" y1="533.8" x2="868.4" y2="533.8"></line>
                <text transform="matrix(1 0 0 1 793.98 537.16)" class="st7 st9 st10">Angola</text>
              </g>
              <g id="_kenya_" class="country_group">
                <path
                  id="Kenya"
                  class="st6"
                  d="M981.3,479.2v-24.8l3.9-3.5l-4.5-4h-4.3l-4.6,4.1h-6.2l-3.2-2.9c-1.3-1.4-3.5-1.5-4.9-0.2
					c-0.1,0.1-0.2,0.2-0.2,0.2c-0.4,0.4-0.9,0.6-1.5,0.6c-0.6,0-1.1-0.2-1.5-0.6l-1.5-1.3l-5.5,0.4v4.8l2.2,2v5.1
					c0,1.5-0.8,2.9-2,3.8c-1.4,0.9-2.3,2.4-2.3,4.1v3.9h-5.9l-4.2,3.8v6.2l3.3,2.9l2.3-2.1h3.9v-4.3l2.6-2.4l10.3,9.2h3.1l3,2.7h3.8
					l6.3,5.7L981.3,479.2z"
                ></path>
                <path
                  class="st7"
                  d="M965,455.2L965,455.2c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C952.5,460.8,958.1,455.2,965,455.2z"
                ></path>
                <line class="st8" x1="965" y1="462.9" x2="965" y2="472.5"></line>
                <line class="st8" x1="960.2" y1="467.7" x2="969.8" y2="467.7"></line>
                <text transform="matrix(1 0 0 1 978.57 474.48)" class="st7 st9 st10">Kenya</text>
              </g>
              <g id="_mozambico_" class="country_group">
                <path
                  class="st6"
                  d="M981.2,530.4v18.3l-19.6,13.9H958l-9.7,9.2l2.1,1.9v4.9l2.4,2.2v10.7c-0.1,1.1-1,1.9-2.1,1.8h-4l-10.5,9.6
					v1.9l-5.4,4.8l-2.7-2.4v-5.2l3.7-3.3h2.7l4-3.6l-7.3-6.6v-8.3l5.1-4.3l0.2-4l5.1-4.3c0.4-0.2,0.7-0.7,0.7-1.2
					c0-0.4-0.2-0.8-0.6-1.1l-2.1-1.8V555l-4.1-3.7h-6.5h6.2l4.6-1.2l5.7,0.3v0.4l2.6,2.3l5.4-4.8v-7.2l-3.6-3.5v-10.5l1.8-1.4
					c0.5-0.8,1.6-1,2.4-0.4c0.1,0.1,0.3,0.2,0.4,0.4l0.7,0.7c1.3,1.1,3.1,1.1,4.4,0.2l1-0.8h7.7l2.5-2.2h3.6l3.9-3.5l0.6,0.3v3.8
					l-2.2,2L981.2,530.4z"
                ></path>
                <path
                  class="st7"
                  d="M949.7,548.2L949.7,548.2c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C937.2,553.8,942.8,548.2,949.7,548.2z"
                ></path>
                <line class="st8" x1="949.7" y1="555.9" x2="949.7" y2="565.5"></line>
                <line class="st8" x1="944.9" y1="560.7" x2="954.5" y2="560.7"></line>
                <text
                  transform="matrix(1 0 0 1 965.05 568.48)"
                  class="st7 st9 st10"
                >{{$ml.current ==='IT' ? 'Mozambico' : 'Mozambique'}}</text>
              </g>
              <g id="_myanmar_" class="country_group">
                <path
                  id="Myanmar"
                  class="st6"
                  d="M1267.1,419.1l-2.9-2.6v-10.2l-2.7-2.5v-4l-5.4-4.8v-8.5h-3l-4.6,7.9h-3.6v-2.6l-1.9-1.7
					v-14.3l-6.5-4.1V369l-9.1-5.3v-2.6l4.6-2.5h5.5v-10.4l3.1-2.8v-8l4.8-4.3v-2.2c0.1-1.4,1.2-2.4,2.6-2.3h3.9l0.3-5.7l0,0l7.4,6.4
					v6l-2.9,2.6l-0.1,5.5c0.1,2,1.8,3.6,3.9,3.5c1.7,0.3,2.9,1.7,3,3.4c0.4,1.1,1.4,1.8,2.6,1.7h2.1v7.2l2.5,2.2v4h-4.2l-4.1,3.7
					l-0.7,0.1c-1.4-0.1-2.5,1-2.6,2.3v5.8l6.7,6v13.2l3.3,2.9v12.1l-1.8,1.6L1267.1,419.1z"
                ></path>
                <path
                  class="st7"
                  d="M1251.7,359.9L1251.7,359.9c6.9,0,12.5,5.6,12.5,12.5l0,0c0,6.9-5.6,12.5-12.5,12.5l0,0
					c-6.9,0-12.5-5.6-12.5-12.5l0,0C1239.2,365.5,1244.8,359.9,1251.7,359.9z"
                ></path>
                <line class="st8" x1="1251.8" y1="367.6" x2="1251.7" y2="377.2"></line>
                <line class="st8" x1="1246.9" y1="372.4" x2="1256.5" y2="372.4"></line>
                <text transform="matrix(1 0 0 1 1271.27 378.86)" class="st7 st9 st10">Myanmar</text>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <transition name="fade">
        <div class="map-modal" v-if="currentCountry !== null" @click="currentCountry = null">
          <svgicon icon="close" width="30" height="30" @click="closeModal"></svgicon>
          <div class="map-modal-content">
            <div
              v-for="(section, sectionIndex) in currentContent.content"
              :key="sectionIndex"
              :class="['map-modal-section',{'map-modal-section-safari':$browserDetect.isSafari}]"
            >
              <div class="map-logo">
                <img :src="`${baseUrl}images/${slug(section.logo)}.svg`">
              </div>
              <div class="title">{{section.title}}</div>
              <div class="section-content">
                <div v-html="section.text" class="map-text"></div>
                <img
                  :src="`${baseUrl}images/${squareImg}.svg`"
                  v-for="(squareImg, imgIndex) in section.images"
                  :key="imgIndex"
                >
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- MOBILE MOBILE MOBILE -->
    <div class="map-mobile" v-if="device !== 'desktop'">
      <div class="tab" v-for="(tab, tabIndex) in content" :key="tabIndex">
        <div class="tab-content" @click="toggleFeatures(tabIndex)">
          <h5>{{tab.country}}</h5>
          <transition name="fade">
            <div :class="['tab-content-content']" v-show-slide="isIncluded(featuresOpen, tabIndex)">
              <div
                class="tab-content-content-content"
                v-for="(element, listIndex) in tab.content"
                :key="listIndex"
              >
                <div class="left-box">
                  <img :src="`${baseUrl}images/${slug(element.logo)}.svg`">
                </div>
                <div class="right-box">
                  <h5>{{element.title}}</h5>
                  <p v-html="element.text">{{element.text}}</p>
                  <div class="sdg-container">
                    <img
                      v-for="(sdg, svgIndex) in element.images"
                      :key="svgIndex"
                      :src="`${baseUrl}images/${sdg}.svg`"
                    >
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import "@/compiled-icons/close";
import slugify from "slugify";

export default {
  props: ["content"],
  data() {
    return {
      currentCountry: null,
      currentOverCountry: null,
      currentContent: "",
      baseUrl: process.env.BASE_URL,
      featuresOpen: []
    };
  },
  methods: {
    closeModal() {
      const countries = document.querySelectorAll(".off");
      countries.forEach(country => {
        country.classList.remove("off");
      });
      this.currentCountry = null;
    },
    toggleFeatures(value) {
      if (this.isIncluded(this.featuresOpen, value)) {
        let index = this.featuresOpen.indexOf(value);
        this.featuresOpen.splice(index, 1);
      } else {
        this.featuresOpen.push(value);
      }
    },
    isIncluded(array, value) {
      return array.indexOf(value) >= 0;
    },
    slug(string) {
      if (string) {
        return slugify(string, {
          lower: true,
          remove: "'"
        });
      } else {
        return "";
      }
    }
  },
  mounted() {
    // let texts = document.querySelectorAll(`.st6 text`);
    // texts.forEach(text => text.setAttribute("style", "opacity: 0"));

    const countries = document.querySelectorAll(".country_group");
    countries.forEach(country => {
      country.addEventListener("click", () => {
        this.currentCountry = country.id;
        this.currentContent = _.find(this.content, countryContent => {
          return countryContent.countryId === this.currentCountry;
        });
      });

      country.addEventListener("mouseenter", () => {
        this.currentOverCountry = country.id;
        countries.forEach(country => {
          if (country.id !== this.currentOverCountry) {
            let shapes = document.querySelectorAll(`#${country.id} .st6`);
            shapes.forEach(shape => {
              shape.classList.add("off");
            });
          } else {
            document
              .querySelector(`#${country.id} text`)
              .setAttribute("style", "opacity: 1");
          }
        });
      });

      country.addEventListener("mouseleave", () => {
        this.currentOverCountry = null;
        countries.forEach(country => {
          if (country.id !== this.currentOverCountry) {
            let shapes = document.querySelectorAll(`#${country.id} .st6`);
            shapes.forEach(shape => {
              shape.classList.remove("off");
            });
            document
              .querySelector(`#${country.id} text`)
              .setAttribute("style", "opacity: 0");
          }
        });
      });
    });
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.st0 {
  fill: #ededec;
  stroke: #ffffff;
  stroke-width: 0.6;
  stroke-miterlimit: 3.8637;
}
.st1 {
  fill: #ededec;
}
.st2 {
  clip-path: url(#SVGID_2_);
}
.st3 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #f2f2f2;
  stroke: #ffffff;
  stroke-width: 0.6;
  stroke-miterlimit: 3.8637;
}
.st4 {
  fill: none;
  stroke: #ffffff;
  stroke-width: 0.6;
  stroke-miterlimit: 3.8637;
}
.st5 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #ededec;
  stroke: #ffffff;
  stroke-width: 0.6;
  stroke-miterlimit: 3.8637;
}
.st6 {
  fill: #ffd500;
  cursor: pointer;
  &.off {
    fill: #cccccc;
  }
}
text {
  opacity: 0;
  font-weight: 700;
}
.st7 {
  fill: #4a4a4a;
  cursor: pointer;
  transition: fill 0.3s;
  line {
    pointer-events: none;
  }
}
.st8 {
  fill: none;
  stroke: #ffffff;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.st9 {
  font-family: "AvenirNext-Bold", sans-serif;
}
.st10 {
  font-size: 16px;
}
.st8,
.st9,
.st10 {
  transition: opacity 0.3s ease;
}
.map-container {
  font-family: "Avenir Next";
  color: $eni-grey;
  position: relative;
  margin: 70px 0;
  .map-desktop {
    svg {
      min-height: 500px;
    }
  }
  .call-to-action {
    position: absolute;
    top: 20px;
    left: 30px;
  }
  .map-modal {
    top: 0;
    left: 0;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    background: rgba(white, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    .map-modal-content {
      display: flex;
      justify-content: space-around;
      .map-modal-section {
        max-width: 300px;
        background: white;
        border-radius: 0.5em;
        -webkit-box-shadow: -1px 0px 12px 1px rgba(0, 0, 0, 0.22);
        -moz-box-shadow: -1px 0px 12px 1px rgba(0, 0, 0, 0.22);
        box-shadow: -1px 0px 12px 1px rgba(0, 0, 0, 0.22);
        margin: 0.6vw;
        position: relative;
        padding: 3.5em 0.8em 1.5em 0.8em;
        display: inline-table;
        &-safari {
          display: inline-block;
        }
        .title {
          font-size: 1.1rem;
          font-weight: 800;
          min-height: 80px;
          border-bottom: 1px solid;
          margin-bottom: 1em;
        }
        .map-text {
          margin-bottom: 1em;
          font-size: 0.9rem;
        }
        .section-content {
          img {
            width: 40px;
            margin: 0.2em;
          }
        }
        .map-logo {
          position: absolute;
          top: 0;
          left: 0.5em;
          transform: translate(0, -50%);
          img {
            width: 80px;
          }
        }
      }
    }
    .svg-icon {
      position: absolute;
      right: 4vh;
      top: 2vh;
      fill: #4a4a4a;
      cursor: pointer;
      min-height: 0;
    }
  }
}
@media (max-width: 1024px) {
  .fade-enter-active {
    transition: height 0.7s ease, opacity 0.7s ease 0.6s;
  }
  .fade-leave-active {
    transition: height 0.7s ease 0.6s, opacity 0.7s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    height: 0 !important;
  }
  .fade-enter-to,
  .fade-leave {
    opacity: 1;
    height: 1000px;
  }
  .map-container {
    width: 100vw;
    display: flex;
    flex-direction: column;
    padding: 10px 70px;
    margin: 50px 0;
    .tab {
      position: relative;
      left: unset;
      width: 100%;
      .tab-content {
        width: 100%;
        border-radius: 10px;
        -webkit-box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
        -moz-box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
        box-shadow: 2px 2px 10px 0px rgba(173, 173, 173, 0.4);
        padding: 20px 30px;
        margin: 10px 0;
        h5 {
          border-left: solid 2px $eni-yellow;
          padding-left: 10px;
          margin-bottom: 10px;
          font-weight: 800;
          font-size: 20px;
          margin: 5px 0;
        }
        .tab-content-content {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          &.open {
            height: 1000px;
          }
          .tab-content-content-content {
            display: flex;
            flex-direction: row;
            padding: 50px 20px;
            border-bottom: solid 1px black;
            &:last-of-type {
              border-bottom: none;
            }
            .left-box {
              width: 30%;
              padding-right: 20px;
              img {
                border: none;
              }
            }
            .right-box {
              width: 70%;
              h5 {
                margin-bottom: 10px;
                font-weight: 800;
                font-size: 20px;
                border-left: none;
              }
              .sdg-container {
                position: relative;
                top: unset;
                left: unset;
                height: 40px;
                width: 100%;
                margin-top: 20px;
                border-bottom: none;
                padding-left: 10px;
                img {
                  height: 35px;
                  margin-right: 5px;
                }
              }
              p {
                border: none;
                padding-left: 10px;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .fade-enter-to,
  .fade-leave {
    opacity: 1;
    height: 320px;
  }
  .map-container {
    padding: 0 20px;
    .tab {
      padding: 10px 0;
      .tab-content {
        .tab-content-content {
          flex-direction: column;
          align-items: flex-start;

          &.open {
            height: 320px;
          }
          .tab-content-content-content {
            flex-direction: column;
            margin-top: 10px;
            padding: 0;
            border-bottom: none;
            &:last-of-type {
              .right-box .sdg-container {
                border-bottom: none;
              }
            }
            .left-box {
              width: 100%;
              img {
                height: 80px;
                padding: 10px;
              }
            }
            .right-box {
              width: 100%;
              p {
                margin-top: 10px;
              }
              .sdg-container {
                height: AUTO;
                width: 100%;
                border-bottom: solid 1px $eni-grey;
                padding-bottom: 20px;
                img {
                  display: inline;
                  height: 38px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
